window.reservedCountsMap = {};

document.addEventListener('DOMContentLoaded', function() {

  const tableBody = document.getElementById('dashTableBody');
  if(!tableBody) return;
  let allRows = Array.from(document.querySelectorAll('.orn-dash__row'));

  const saveBtn = document.getElementById('dashSaveBtn');
  const bottomBar = document.getElementById('ornBottomBar');
  const searchInput = document.getElementById('dashSearch');
  const filterBtns = document.querySelectorAll('.orn-dash__filter-btn');

  let filteredRows = [];

  function getLocalOrdersFromDOM(doc = document) {
     const store = doc.getElementById('ornataDataStore');
     if(!store) return [];
     const raw = store.getAttribute('data-orders');
     try { return JSON.parse(raw) || []; } catch(e) { return []; }
  }

  let localOrders = getLocalOrdersFromDOM();

  let pendingOrderTags = { add: [], remove: [] };
  let pendingOrderSampleEdits = {};
  let pendingOrderSampleEditsOriginal = {};
  let pendingGratisSampleStateChecks = [];
  let orderSampleEditLog = {};

    localOrders.forEach(order => {
      if (order.sample_edits) {
        Object.entries(order.sample_edits).forEach(([setIdx, log]) => {
          orderSampleEditLog[order.id + '-' + setIdx] = log;
        });
      }
    });
  let isManualMode = false;
  let currentEditOrderId = null;
  let currentEditSetIndex = 0;

let currentEditGratisSampleIdx = 0; // Bijhouden welke gratis sample wordt bewerkt in modal

function getGratisSamplesArray(order) {
  if (order.gratis_samples && Array.isArray(order.gratis_samples) && order.gratis_samples.length > 0) {
    return order.gratis_samples;
  }
  if (order.gratis_sample) {
    return [{
      product: order.gratis_product || '',
      sample: order.gratis_sample,
      sample_id: order.gratis_sample_id || '',
      deducted: !!(order.is_deducted),
      no_deduct: !!(order.no_deduct_needed)
    }];
  }
  return [];
}

function allGratisSamplesHandled(samples) {
  return samples.length > 0 && samples.every(s => s.deducted || s.no_deduct);
}

function anyGratisSampleHandled(samples) {
  return samples.some(s => s.deducted || s.no_deduct);
}

function hasSetContent(order) {
  return !!(order.sets && Array.isArray(order.sets) && order.sets.length > 0);
}

function hasGratisSampleContent(order) {
  return getGratisSamplesArray(order).length > 0;
}

function isMixedSampleOrder(order) {
  return hasSetContent(order) && hasGratisSampleContent(order);
}

function areSetSamplesHandled(order) {
  if (!hasSetContent(order)) return true;
  if (isMixedSampleOrder(order)) return !!order.sets_deducted;
  return !!order.is_deducted;
}

function areGratisSamplesHandled(order) {
  const samples = getGratisSamplesArray(order);
  return samples.length === 0 || allGratisSamplesHandled(samples);
}

function isWholeOrderHandled(order) {
  return areSetSamplesHandled(order) && areGratisSamplesHandled(order);
}

function updateStoredOrderCompletion(order, orderId) {
  const fullyHandled = isWholeOrderHandled(order);
  order.is_deducted = fullyHandled;

  pendingOrderTags.add = pendingOrderTags.add.filter(id => id !== orderId);
  pendingOrderTags.remove = pendingOrderTags.remove.filter(id => id !== orderId);

  if (fullyHandled) {
    pendingOrderTags.add.push(orderId);
  } else {
    pendingOrderTags.remove.push(orderId);
  }
}

function renderMixedGratisSamplesSection(order) {
  const samples = getGratisSamplesArray(order);
  if (!samples.length) return '';

  let samplesHtml = '';
  samples.forEach((sample, sIdx) => {
    const sHandled = sample.deducted || sample.no_deduct;
    const sStatusLabel = sample.deducted
      ? `<span style="font-size:10px;font-weight:700;color:var(--dash-green);white-space:nowrap;">✓ Afgeschreven</span>`
      : sample.no_deduct
        ? `<span style="font-size:10px;font-weight:700;color:#3b82f6;white-space:nowrap;">✓ Geen afschr.</span>`
        : '';

    const sDisplay = (sample.sample || '—')
      .replace(/^Andere sample:\s*/i, '')
      .replace(/^Sample van dit parfum\s*\(/i, '')
      .replace(/\)$/, '');

    const bgColor = sHandled ? 'var(--dash-bg)' : '#ffffff';
    const opacity = sHandled ? '0.65' : '1';

    samplesHtml += `
      <div class="orn-gs-sample-block" style="border:1px solid var(--dash-border);border-radius:6px;padding:10px;margin-bottom:8px;background:${bgColor};opacity:${opacity};">
        ${sample.product ? `<div style="font-size:10px;font-weight:700;color:#6b7280;text-transform:uppercase;letter-spacing:0.03em;margin-bottom:6px;">${sample.product}</div>` : ''}
        <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;flex-wrap:wrap;margin-bottom:6px;">
          <span class="orn-dash__sample-pill" data-samplename="${sDisplay.replace(/"/g,'&quot;')}" data-product-id="${sample.sample_id||''}">${sDisplay}</span>
          ${sStatusLabel}
        </div>
        <div id="gs-wrapper-actions-${order.id}-${sIdx}" style="display:flex;gap:6px;flex-wrap:wrap;">
          <button type="button" class="orn-btn-outline gratis-edit-btn"
            data-id="${order.id}" data-sample-idx="${sIdx}"
            style="flex:1;font-size:10px;padding:4px 8px;"
            ${sHandled ? 'disabled' : ''}>Bewerken</button>
          ${sHandled ? `
            <button type="button" class="gs-prompt-action-btn orn-btn-outline"
              data-action="${sample.deducted ? 'herstel' : 'reset-geen'}" data-id="${order.id}" data-sample-idx="${sIdx}"
              style="flex:1;font-size:10px;padding:4px 8px;color:var(--dash-orange);border-color:var(--dash-orange);">↩ Herstel</button>
          ` : `
            <button type="button" class="gs-prompt-action-btn orn-btn-solid"
              data-action="afschrijven" data-id="${order.id}" data-sample-idx="${sIdx}"
              style="flex:1;font-size:10px;padding:4px 8px;">− Afschr.</button>
            <button type="button" class="gs-prompt-action-btn orn-btn-outline"
              data-action="geen" data-id="${order.id}" data-sample-idx="${sIdx}"
              style="flex:1;font-size:10px;padding:4px 8px;">✓ Geen</button>
          `}
        </div>
        <div class="orn-dash__confirm-box" id="gs-confirm-${order.id}-${sIdx}" hidden style="margin-top:8px;">
          <p class="orn-dash__confirm-text" id="gs-confirm-text-${order.id}-${sIdx}"></p>
          <div class="orn-dash__confirm-actions">
            <button type="button" class="orn-btn-outline gs-cancel-action-btn"
              data-id="${order.id}" data-sample-idx="${sIdx}">Annuleren</button>
            <button type="button" class="orn-btn-solid gs-confirm-action-btn"
              data-id="${order.id}" data-sample-idx="${sIdx}"
              id="gs-confirm-btn-${order.id}-${sIdx}">Ja, opslaan</button>
          </div>
        </div>
      </div>
    `;
  });

  return `
    <div class="orn-dash__order-set" style="margin-top:12px;">
      <div class="orn-dash__set-title">Gratis sample${samples.length > 1 ? 's' : ''}:</div>
      ${samplesHtml}
    </div>
  `;
}

async function handleGratisSampleAction(orderId, sampleIdx, action) {
  const orderIndex = localOrders.findIndex(o => o.id.toString() === orderId);
  if (orderIndex === -1) return;
  const order = localOrders[orderIndex];

  if (!order.gratis_samples || !Array.isArray(order.gratis_samples)) {
    order.gratis_samples = getGratisSamplesArray(order);
  }

  const sample = order.gratis_samples[sampleIdx];
  if (!sample) return;

  function findRowByProductId(productId) {
    if (!productId) return null;
    return allRows.find(r => r.getAttribute('data-product-id').toString() === productId.toString()) || null;
  }

  if (action === 'afschrijven' || (action === 'herstel' && sample.deducted)) {
    const row = findRowByProductId(sample.sample_id);
    if (!row) {
      alert("Deze gratis sample heeft geen geldige product-ID. Open 'Aanpassen', selecteer de sample opnieuw en probeer daarna opnieuw.");
      return;
    }

    const si = row.querySelector('.stock-input');
    if (action === 'afschrijven') {
      si.value = (parseInt(si.value, 10) || 0) - 1;
      updateRowUI(row, true);
      sample.deducted = true;
      sample.no_deduct = false;
    } else {
      si.value = (parseInt(si.value, 10) || 0) + 1;
      updateRowUI(row, true);
      sample.deducted = false;
      sample.no_deduct = false;
    }
  } else if (action === 'geen') {
    sample.deducted = false;
    sample.no_deduct = true;
  } else if (action === 'reset-geen') {
    sample.deducted = false;
    sample.no_deduct = false;
  }

  pendingGratisSampleStateChecks = pendingGratisSampleStateChecks.filter(c => !(c.orderId === orderId && c.sampleIdx === sampleIdx));
  pendingGratisSampleStateChecks.push({
    orderId: orderId,
    sampleIdx: sampleIdx,
    deducted: !!sample.deducted,
    no_deduct: !!sample.no_deduct
  });

  order.no_deduct_needed = false;
  updateStoredOrderCompletion(order, orderId);

  calculateReservations();
  checkUnsavedChanges();
  await saveDashboardData();
}

  let modalSelectedSamples = [];
  let modalSelectedSampleIds = []; // ID-FIX: betrouwbare selectie voor afschrijving

  let allPerfumesList = allRows.map(row => {
    return {
      id: row.getAttribute('data-product-id'),
      name: row.querySelector('.orn-dash__td-name strong').textContent.trim(),
      vendor: row.querySelector('.orn-dash__vendor').textContent.trim(),
      image: row.getAttribute('data-image') || '',
      searchKey: row.getAttribute('data-search'),
      premium: row.getAttribute('data-premium') === 'true',
      rowElement: row
    };
  });

  function normalizeDashboardPremiumCount(value) {
    const count = parseInt(value || 0, 10);
    if (!Number.isFinite(count)) return 0;
    return Math.max(0, Math.min(5, count));
  }

  function isLegacyPremiumMetadataText(value) {
    return typeof value === 'string' && /^(?:aantal\s+premium\s+samples?|_premium_sample_count)\s*:/i.test(value.trim());
  }

  function getOrderSetPremiumCount(set) {
    if (set && set.premium_count !== undefined && set.premium_count !== null && set.premium_count !== '') {
      return normalizeDashboardPremiumCount(set.premium_count);
    }

    const legacyText = Array.isArray(set && set.samples)
      ? set.samples.find(isLegacyPremiumMetadataText)
      : '';
    const match = legacyText ? legacyText.match(/:\s*(\d+)/) : null;
    return normalizeDashboardPremiumCount(match ? match[1] : 0);
  }

  function isPerfumePremium(perfume) {
    if (!perfume) return false;
    const liveToggle = perfume.rowElement ? perfume.rowElement.querySelector('.premium-toggle') : null;
    return liveToggle ? liveToggle.checked : perfume.premium === true;
  }

  function getPremiumSelectionCount(productIds) {
    return (productIds || []).reduce((count, productId) => {
      const perfume = allPerfumesList.find(item => String(item.id) === String(productId));
      return count + (isPerfumePremium(perfume) ? 1 : 0);
    }, 0);
  }

  function updateRowUI(row, isUserInput = false) {
    const stock = parseInt(row.querySelector('.stock-input').value, 10) || 0;
    const minLim = parseInt(row.querySelector('.min-voorraad-input').value, 10) || 0;
    const stopLim = parseInt(row.querySelector('.stop-limiet-input').value, 10) || 0;

    const pid = row.getAttribute('data-product-id');
    const reserved = window.reservedCountsMap[pid] || 0;
    const effectiveStock = stock - reserved;

    row.classList.remove('status-green', 'status-orange', 'status-red');

    if (effectiveStock <= stopLim || stock <= 0) {
       row.classList.add('status-red');
    } else if (effectiveStock < minLim) {
       row.classList.add('status-orange');
    } else {
       row.classList.add('status-green');
    }

    const warningEl = row.querySelector('.orn-dash__limit-warning');
    const onlineToggle = row.querySelector('.online-toggle');
    const exclusiveToggle = row.querySelector('.exclusive-toggle');

    if (exclusiveToggle.checked) {
      if (warningEl) {
         warningEl.hidden = false;
         warningEl.innerHTML = "Store<br>Excl.";
         warningEl.style.color = "var(--dash-dark)";
      }
    } else if (effectiveStock <= stopLim) {
      if (warningEl) {
         warningEl.hidden = false;
         warningEl.innerHTML = "Niet<br>beschikbaar";
         warningEl.style.color = "var(--dash-red)";
      }
      if (isUserInput && onlineToggle.checked) {
         onlineToggle.checked = false;
      }
    } else {
      if (warningEl) warningEl.hidden = true;
      if (isUserInput && !onlineToggle.checked && stock > stopLim) {
         onlineToggle.checked = true;
      }
    }

    if (onlineToggle.checked) {
       row.classList.add('is-active');
       row.classList.remove('is-inactive');
    } else {
       row.classList.remove('is-active');
       row.classList.add('is-inactive');
    }

    if (exclusiveToggle.checked) {
       row.classList.add('is-exclusive');
    } else {
       row.classList.remove('is-exclusive');
    }

    const mailToggle = row.querySelector('.mail-toggle');
    if (mailToggle && mailToggle.checked) {
       row.classList.add('in-mail');
       row.classList.remove('not-in-mail');
    } else if (mailToggle) {
       row.classList.add('not-in-mail');
       row.classList.remove('in-mail');
    } else {
       row.classList.remove('in-mail', 'not-in-mail');
    }

    const premiumToggle = row.querySelector('.premium-toggle');
    if (premiumToggle) {
      row.classList.toggle('is-premium', premiumToggle.checked);
      row.setAttribute('data-premium', premiumToggle.checked.toString());
    }

    if (typeof updateAnalyticsTable === 'function') {
       updateAnalyticsTable();
    }
  }

  function updateCountBadges() {
    let cRed = 0, cOrange = 0, cGreen = 0;
    let cRes = 0, cPremium = 0, cExcl = 0, cAct = 0, cInact = 0, cNotMail = 0, cInMail = 0;

    allRows.forEach(row => {
      if (row.classList.contains('status-red')) cRed++;
      else if (row.classList.contains('status-orange')) cOrange++;
      else cGreen++;

      if (row.classList.contains('has-reservations')) cRes++;
      if (row.classList.contains('is-premium')) cPremium++;
      if (row.classList.contains('is-exclusive')) cExcl++;
      if (row.classList.contains('is-active')) cAct++;
      if (row.classList.contains('is-inactive')) cInact++;
      if (row.classList.contains('not-in-mail')) cNotMail++;
      if (row.classList.contains('in-mail')) cInMail++;
    });

    document.getElementById('countRed').textContent = cRed;
    document.getElementById('countOrange').textContent = cOrange;
    document.getElementById('countGreen').textContent = cGreen;

    if(document.getElementById('countReserved')) document.getElementById('countReserved').textContent = cRes;
    if(document.getElementById('countPremium')) document.getElementById('countPremium').textContent = cPremium;
    if(document.getElementById('countExclusive')) document.getElementById('countExclusive').textContent = cExcl;
    if(document.getElementById('countActive')) document.getElementById('countActive').textContent = cAct;
    if(document.getElementById('countInactive')) document.getElementById('countInactive').textContent = cInact;
    if(document.getElementById('countNotInMail')) document.getElementById('countNotInMail').textContent = cNotMail;
    if(document.getElementById('countInMail')) document.getElementById('countInMail').textContent = cInMail;
  }

  function calculateReservations() {
    let reservedCounts = {};

    localOrders.forEach(order => {
      if (!areSetSamplesHandled(order) && order.sets) {
        order.sets.forEach(set => {
          getDisplayItemsForOrderSet(set).forEach(item => {
            const sampleName = (item.name || '').toString().trim();
            if (!sampleName || sampleName === 'Geen specifieke geuren doorgegeven' || sampleName === 'Geen voorkeur doorgegeven') return;

            let id = normalizeProductIdForCompare(item.id || '');
            let extractedNames = [];

            if (!id && sampleName.toLowerCase().includes('set:') && sampleName.includes('(') && sampleName.includes(')')) {
              const match = sampleName.match(/\(([^)]+)\)/);
              extractedNames = match ? match[1].split(',').map(s => s.trim()) : [sampleName];
            } else {
              extractedNames = [sampleName];
            }

            if (id && extractedNames.length === 1) {
              reservedCounts[id] = (reservedCounts[id] || 0) + 1;
              return;
            }

            extractedNames.forEach(extractedName => {
              const cleanName = extractedName.toLowerCase().replace(/[^a-z0-9]/g, '');
              const matchedPerfume = allPerfumesList.find(p => {
                const cleanP = p.name.toLowerCase().replace(/[^a-z0-9]/g, '');
                return cleanP.length > 2 && cleanName === cleanP;
              });
              if (matchedPerfume) {
                const cleanId = normalizeProductIdForCompare(matchedPerfume.id);
                if (cleanId) reservedCounts[cleanId] = (reservedCounts[cleanId] || 0) + 1;
              }
            });
          });
        });
      }
{
  const gsSamples = getGratisSamplesArray(order);
  gsSamples.forEach(gs => {
    if (gs.deducted || gs.no_deduct) return; // Al verwerkt, niet meer reserveren
    if (gs.sample_id && gs.sample_id !== '') {
      const gsId = normalizeProductIdForCompare(gs.sample_id);
      if (gsId) reservedCounts[gsId] = (reservedCounts[gsId] || 0) + 1;
    } else if (gs.sample) {
      const cleanName = gs.sample.replace(/^Andere sample:\s*/i, '').toLowerCase().replace(/[^a-z0-9]/g, '');
      const matchedPerfume = allPerfumesList.find(p => {
        const cleanP = p.name.toLowerCase().replace(/[^a-z0-9]/g, '');
        return cleanP.length > 2 && cleanName === cleanP;
      });
      if (matchedPerfume) {
        reservedCounts[matchedPerfume.id] = (reservedCounts[matchedPerfume.id] || 0) + 1;
      }
    }
});
}

    }); // sluit localOrders.forEach

    window.reservedCountsMap = reservedCounts;

    allRows.forEach(row => {
      const pid = row.getAttribute('data-product-id');
      const badge = row.querySelector('.orn-dash__reserved-badge');
      const count = reservedCounts[pid] || 0;

      if (count > 0) {
        badge.querySelector('span').textContent = count + ' gereserveerd';
        badge.hidden = false;
        row.classList.add('has-reservations');
      } else {
        badge.hidden = true;
        row.classList.remove('has-reservations');
      }
      updateRowUI(row, false);
    });
  }

  function getReservationOrdersForProduct(productId) {
    const pid = normalizeProductIdForCompare(productId);
    const foundOrders = [];

    localOrders.forEach(order => {
      let found = false;

      if (!areSetSamplesHandled(order)) {
        (order.sets || []).forEach(set => {
          if (found) return;
          getDisplayItemsForOrderSet(set).forEach(item => {
            if (found) return;
            if (normalizeProductIdForCompare(item.id || '') === pid) found = true;
          });
        });
      }

      if (!found) {
        getGratisSamplesArray(order).forEach(gs => {
          if (found || gs.deducted || gs.no_deduct) return;
          if (normalizeProductIdForCompare(gs.sample_id || '') === pid) found = true;
        });
      }

      if (found) foundOrders.push(order);
    });

    return foundOrders;
  }

  function hideReservationPopover() {
    const old = document.getElementById('ornReservationPopover');
    if (old) old.remove();
  }

  function showReservationPopover(badge, productId) {
    hideReservationPopover();

    const orders = getReservationOrdersForProduct(productId);
    const pop = document.createElement('div');
    pop.id = 'ornReservationPopover';
    pop.className = 'orn-res-pop';

    const rows = orders.length
      ? orders.map(order => `<div class="orn-res-pop__item"><b>${order.name || ''}</b><br>${order.customer || 'Onbekende klant'}</div>`).join('')
      : '<div class="orn-res-pop__item">Geen open reserveringen gevonden.</div>';

    pop.innerHTML = `<strong>Gereserveerd in</strong>${rows}`;
    document.body.appendChild(pop);

    const r = badge.getBoundingClientRect();
    const left = Math.min(window.innerWidth - 255, Math.max(8, r.left));
    const top = Math.min(window.innerHeight - pop.offsetHeight - 8, r.bottom + 8);
    pop.style.left = left + 'px';
    pop.style.top = top + 'px';
  }

  function calculateRecommendedStock() {
    let avgMap = {};
    document.querySelectorAll('.analytics-row').forEach(aRow => {
       avgMap[aRow.getAttribute('data-id')] = parseFloat(aRow.getAttribute('data-avg')) || 0;
    });

    allRows.forEach(row => {
       const pid = row.getAttribute('data-product-id');
       const minLim = parseInt(row.querySelector('.min-voorraad-input').value, 10) || 0;
       const badge = row.querySelector('.orn-dash__recommended-badge');
       const span = badge.querySelector('span');

       const avgDay = avgMap[pid] || 0;
       const avgWeek = avgDay * 7;

       const recommended = Math.max(Math.ceil(avgWeek), minLim);

       if (recommended > 0) {
          span.textContent = 'Aanbevolen: ' + recommended;
          badge.hidden = false;
       } else {
          badge.hidden = true;
       }
    });
  }

  function checkUnsavedChanges() {
    try {
      let hasChanges = false;
      allRows.forEach(row => {
        const stockInput = row.querySelector('.stock-input');
        const minInput = row.querySelector('.min-voorraad-input');
        const stopInput = row.querySelector('.stop-limiet-input');
        const exclToggle = row.querySelector('.exclusive-toggle');
        const onlineToggle = row.querySelector('.online-toggle');
        const mailToggle = row.querySelector('.mail-toggle');
        const limitedToggle = row.querySelector('.limited-toggle');
        const premiumToggle = row.querySelector('.premium-toggle');

        if (stockInput && (parseInt(stockInput.value, 10) || 0) !== (parseInt(stockInput.getAttribute('data-original'), 10) || 0)) hasChanges = true;
        if (minInput && (parseInt(minInput.value, 10) || 0) !== (parseInt(minInput.getAttribute('data-original'), 10) || 0)) hasChanges = true;
        if (stopInput && (parseInt(stopInput.value, 10) || 0) !== (parseInt(stopInput.getAttribute('data-original'), 10) || 0)) hasChanges = true;
        if (exclToggle && exclToggle.checked.toString() !== exclToggle.getAttribute('data-original')) hasChanges = true;
        if (onlineToggle && onlineToggle.checked.toString() !== onlineToggle.getAttribute('data-original')) hasChanges = true;
        if (mailToggle && mailToggle.checked.toString() !== mailToggle.getAttribute('data-original')) hasChanges = true;
        if (limitedToggle && limitedToggle.checked.toString() !== limitedToggle.getAttribute('data-original')) hasChanges = true;
        if (premiumToggle && premiumToggle.checked.toString() !== premiumToggle.getAttribute('data-original')) hasChanges = true;
      });

      if (pendingOrderTags.add.length > 0 || pendingOrderTags.remove.length > 0 || Object.keys(pendingOrderSampleEdits).length > 0 || pendingGratisSampleStateChecks.length > 0) {
        hasChanges = true;
      }

      if (Object.keys(pendingSetEdits).length > 0 ||
          pendingSetsCreate.length > 0 ||
          pendingSetsDelete.length > 0) {
        hasChanges = true;
      }

      if (pendingTellingResults.length > 0) {
        hasChanges = true;
      }

      const buisjesInp = document.getElementById('buisjesVoorraadInput');
      if (buisjesInp) {
        if ((parseInt(buisjesInp.value, 10) || 0) !== (parseInt(buisjesInp.getAttribute('data-original'), 10) || 0)) {
          hasChanges = true;
        }
      }

      if(hasChanges) {
        bottomBar.classList.add('is-visible');
        saveBtn.disabled = false;
      } else {
        bottomBar.classList.remove('is-visible');
        saveBtn.disabled = true;
      }
      updateCountBadges();
    } catch(err) {
      console.error("Fout bij controleren van wijzigingen:", err);
    }
  }

  const globalLoader = document.getElementById('ornGlobalLoader');
  const loaderTitle = document.getElementById('ornLoaderTitle');
  const loaderText = document.getElementById('ornLoaderText');

  function createDashboardOperationId() {
    return 'orn_op_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
  }

  function buildOrderStatePatchesForSave() {
    const ids = new Set();

    pendingOrderTags.add.forEach(id => ids.add(String(id)));
    pendingOrderTags.remove.forEach(id => ids.add(String(id)));

    Object.keys(pendingOrderSampleEdits).forEach(key => {
      ids.add(String(key).split('-')[0]);
    });

    pendingGratisSampleStateChecks.forEach(check => {
      ids.add(String(check.orderId));
    });

    return Array.from(ids)
      .map(id => localOrders.find(o => String(o.id) === String(id)))
      .filter(Boolean);
  }

  function buildOrderStateVerifyConditions(orderPatches) {
    return orderPatches.map(order => ({
      type: 'order_state',
      id: String(order.id),
      is_deducted: !!order.is_deducted,
      sets_deducted: !!order.sets_deducted,
      has_sets_deducted: order.sets_deducted !== undefined,
      gratis_samples: getGratisSamplesArray(order).map(sample => ({
        deducted: !!sample.deducted,
        no_deduct: !!sample.no_deduct,
        sample_id: String(sample.sample_id || '')
      }))
    }));
  }

  function checkSinglePollCondition(condition, doc) {
    if (!condition) return true;

    if (condition.type === 'stock') {
      const row = doc.querySelector(`.orn-dash__row[data-product-id="${condition.id}"]`);
      if (!row) return false;
      const stockInput = row.querySelector('.stock-input');
      if (!stockInput) return false;
      const stockVal = parseInt(stockInput.value, 10);
      return stockVal === condition.val;
    }

    if (condition.type === 'premium') {
      const row = doc.querySelector(`.orn-dash__row[data-product-id="${condition.id}"]`);
      const premiumToggle = row ? row.querySelector('.premium-toggle') : null;
      return !!(premiumToggle && premiumToggle.checked === condition.val);
    }

    if (condition.type === 'order') {
      const checkOrders = getLocalOrdersFromDOM(doc);
      const o = checkOrders.find(o => o.id.toString() === condition.id);
      return !!(o && o.is_deducted === condition.val);
    }

    if (condition.type === 'order_state') {
      const checkOrders = getLocalOrdersFromDOM(doc);
      const o = checkOrders.find(o => String(o.id) === String(condition.id));
      if (!o) return false;

      if (!!o.is_deducted !== !!condition.is_deducted) return false;
      if (condition.has_sets_deducted && !!o.sets_deducted !== !!condition.sets_deducted) return false;

      const liveSamples = getGratisSamplesArray(o);
      const expectedSamples = condition.gratis_samples || [];
      if (liveSamples.length !== expectedSamples.length) return false;

      for (let i = 0; i < expectedSamples.length; i++) {
        const live = liveSamples[i] || {};
        const expected = expectedSamples[i] || {};
        if (!!live.deducted !== !!expected.deducted) return false;
        if (!!live.no_deduct !== !!expected.no_deduct) return false;
        if (String(live.sample_id || '') !== String(expected.sample_id || '')) return false;
      }

      return true;
    }

    if (condition.type === 'gratis_state') {
      const checkOrders = getLocalOrdersFromDOM(doc);
      const o = checkOrders.find(o => o.id.toString() === condition.id);
      const gs = o ? getGratisSamplesArray(o)[condition.sampleIdx] : null;
      return !!(gs && !!gs.deducted === condition.deducted && !!gs.no_deduct === condition.no_deduct);
    }

    if (condition.type === 'buisjes') {
      const freshBuisjes = doc.getElementById('buisjesVoorraadInput');
      return !!(freshBuisjes && (parseInt(freshBuisjes.getAttribute('data-original'), 10) || 0) === condition.val);
    }

    if (condition.type === 'sets_create') {
      const freshBody = doc.getElementById('setsManageBody');
      if (!freshBody) return false;
      return Array.from(freshBody.querySelectorAll('.sets-manage-row'))
        .some(r => r.getAttribute('data-set-title') === condition.title);
    }

    if (condition.type === 'sets_update') {
      const freshBody = doc.getElementById('setsManageBody');
      if (!freshBody) return false;

      const row = Array.from(freshBody.querySelectorAll('.sets-manage-row'))
        .find(r => r.getAttribute('data-set-id') === condition.id);
      if (!row) return false;

      if (condition.sort_order !== -1) {
        if ((parseInt(row.getAttribute('data-set-sort'), 10) || 0) !== condition.sort_order) return false;
      }

      if (condition.is_active !== null) {
        const freshActive = row.getAttribute('data-set-is-active') !== 'false';
        if (freshActive !== condition.is_active) return false;
      }

      if (condition.product_count !== -1) {
        const freshPids = (row.getAttribute('data-set-pids') || '').split(',').filter(Boolean);
        if (freshPids.length !== condition.product_count) return false;
      }

      return true;
    }

    if (condition.type === 'sets_delete') {
      const freshBody = doc.getElementById('setsManageBody');
      if (!freshBody) return false;

      return !Array.from(freshBody.querySelectorAll('.sets-manage-row'))
        .some(r => r.getAttribute('data-set-id') === condition.id);
    }

    return true;
  }

  async function saveCompleteSetsSeparately(setCreatePayload, setUpdatePayload, setDeletePayload) {
    const hasSetChanges =
      (setCreatePayload && setCreatePayload.length > 0) ||
      (setUpdatePayload && setUpdatePayload.length > 0) ||
      (setDeletePayload && setDeletePayload.length > 0);

    if (!hasSetChanges) return { ok: true, skipped: true };

    const setsWebhookUrl = "https://webhooks.mechanic.dev/67a691f4-654c-41f8-b03a-beca55700240";

    if (!setsWebhookUrl || setsWebhookUrl.includes('PLAATS_HIER')) {
      throw new Error('Complete Sets webhook URL ontbreekt nog in de dashboardcode.');
    }

    const payload = {
      operation_id: createDashboardOperationId(),
      complete_sets_create: setCreatePayload || [],
      complete_sets_update: setUpdatePayload || [],
      complete_sets_delete: setDeletePayload || []
    };

    const response = await fetch(setsWebhookUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error('Complete Sets webhook gaf geen OK terug.');
    }

    return { ok: true, skipped: false };
  }

async function saveDashboardData(sourceBtn = null) {
    try {
      if (sourceBtn) sourceBtn.disabled = true;
      saveBtn.disabled = true;

      let updates = [];
      allRows.forEach(row => {
        const stockInput = row.querySelector('.stock-input');
        const minInput = row.querySelector('.min-voorraad-input');
        const stopInput = row.querySelector('.stop-limiet-input');
        const exclToggle = row.querySelector('.exclusive-toggle');
        const onlineToggle = row.querySelector('.online-toggle');
        const mailToggle = row.querySelector('.mail-toggle');
        const limitedToggle = row.querySelector('.limited-toggle');
        const premiumToggle = row.querySelector('.premium-toggle');
        const premiumChanged = !!(premiumToggle && premiumToggle.checked.toString() !== premiumToggle.getAttribute('data-original'));

        if (stockInput.value !== stockInput.getAttribute('data-original') ||
            minInput.value !== minInput.getAttribute('data-original') ||
            stopInput.value !== stopInput.getAttribute('data-original') ||
            exclToggle.checked.toString() !== exclToggle.getAttribute('data-original') ||
            onlineToggle.checked.toString() !== onlineToggle.getAttribute('data-original') ||
            mailToggle.checked.toString() !== mailToggle.getAttribute('data-original') ||
            (limitedToggle && limitedToggle.checked.toString() !== limitedToggle.getAttribute('data-original')) ||
            premiumChanged) {

          updates.push({
            product_id: row.getAttribute('data-product-id'),
            stock: parseInt(stockInput.value, 10),
            stock_original: parseInt(stockInput.getAttribute('data-original'), 10) || 0,
            min_voorraad: parseInt(minInput.value, 10),
            stop_limiet: parseInt(stopInput.value, 10),
            store_exclusive: exclToggle.checked,
            online_beschikbaar: onlineToggle.checked,
            include_in_restock_email: mailToggle.checked,
            sample_limited: limitedToggle ? limitedToggle.checked : false,
            sample_toeslag: premiumToggle && premiumToggle.checked ? 2 : 0,
            sample_toeslag_original: premiumToggle && premiumToggle.getAttribute('data-original') === 'true' ? 2 : 0
          });
        }
      });

      let editsArray = [];

const setCreatePayload = pendingSetsCreate.map(function(s) {
        return { title: s.title, description: s.description,
                 sort_order: s.sort_order, is_active: s.is_active,
                 product_ids: s.product_ids };
      });
      const setUpdatePayload = Object.entries(pendingSetEdits).map(function(kv) {
        if (kv[0].startsWith('new-')) return null;
        return Object.assign({ id: kv[0] }, kv[1]);
      }).filter(Boolean);
      const setDeletePayload = pendingSetsDelete.slice();
      const hasSetsChanges = setCreatePayload.length > 0 || setUpdatePayload.length > 0 || setDeletePayload.length > 0;

      let hasOrderChanges =
        pendingOrderTags.add.length > 0 ||
        pendingOrderTags.remove.length > 0 ||
        Object.keys(pendingOrderSampleEdits).length > 0 ||
        pendingGratisSampleStateChecks.length > 0 ||
        hasSetsChanges;

      const buisjesInpSave = document.getElementById('buisjesVoorraadInput');
      const buisjesValueSave = buisjesInpSave ? (parseInt(buisjesInpSave.value, 10) || 0) : null;
      const buisjesOrigSave = buisjesInpSave ? (parseInt(buisjesInpSave.getAttribute('data-original'), 10) || 0) : null;
      const buisjesChangedSave = buisjesValueSave !== buisjesOrigSave;

      if (updates.length === 0 && !hasOrderChanges && !buisjesChangedSave) {
        if (pendingTellingResults.length > 0) {
          globalLoader.hidden = false;
          loaderTitle.textContent = 'Telling opslaan...';
          loaderText.textContent = `${pendingTellingResults.length} telresultaat/resultaten worden verwerkt...`;
          await savePendingTellingResults();
          loaderTitle.textContent = 'Voltooid!';
          loaderText.textContent = 'Telresultaten opgeslagen.';
          checkUnsavedChanges();
          setTimeout(() => {
            globalLoader.hidden = true;
            if (sourceBtn) sourceBtn.disabled = false;
            saveBtn.disabled = true;
          }, 800);
          return true;
        }
        saveBtn.disabled = false;
        if (sourceBtn) sourceBtn.disabled = false;
        return true;
      }

const operationId = createDashboardOperationId();

      const stockOperations = updates
        .filter(item => Number.isFinite(item.stock) && Number.isFinite(item.stock_original) && item.stock !== item.stock_original)
        .map(item => ({
          operation_id: operationId,
          product_id: item.product_id,
          expected_stock: item.stock_original,
          delta: item.stock - item.stock_original,
          target_stock: item.stock
        }));

      const orderStatePatches = buildOrderStatePatchesForSave();

      let pollConditions = [];

      stockOperations.forEach(op => {
        pollConditions.push({ type: 'stock', id: op.product_id, val: op.target_stock });
      });

      updates.forEach(item => {
        if (item.sample_toeslag !== item.sample_toeslag_original) {
          pollConditions.push({ type: 'premium', id: item.product_id, val: item.sample_toeslag === 2 });
        }
      });

      pollConditions = pollConditions.concat(buildOrderStateVerifyConditions(orderStatePatches));

      if (buisjesChangedSave) {
        pollConditions.push({ type: 'buisjes', val: buisjesValueSave });
      }

      if (hasSetsChanges) {
        if (setCreatePayload.length > 0) {
          pollConditions.push({ type: 'sets_create', title: setCreatePayload[0].title });
        } else if (setUpdatePayload.length > 0) {
          pollConditions.push({
            type: 'sets_update',
            id: setUpdatePayload[0].id,
            product_count: setUpdatePayload[0].product_ids ? setUpdatePayload[0].product_ids.length : -1,
            sort_order: setUpdatePayload[0].sort_order !== undefined ? setUpdatePayload[0].sort_order : -1,
            is_active: setUpdatePayload[0].is_active !== undefined ? setUpdatePayload[0].is_active : null
          });
        } else if (setDeletePayload.length > 0) {
          pollConditions.push({ type: 'sets_delete', id: setDeletePayload[0] });
        }
      }

      globalLoader.hidden = false;
      loaderTitle.textContent = 'Data verzenden...';

      let totalActions = stockOperations.length + orderStatePatches.length + setCreatePayload.length + setUpdatePayload.length + setDeletePayload.length;
      const nonStockProductUpdates = updates.filter(item => !stockOperations.some(op => String(op.product_id) === String(item.product_id))).length;
      totalActions += nonStockProductUpdates;
      if (buisjesChangedSave) totalActions += 1;
      if (totalActions === 0) totalActions = 1;

      loaderText.textContent = `Shopify verwerkt momenteel ${totalActions} wijziging(en). Complete sets en voorraad worden gescheiden opgeslagen...`;

      await saveCompleteSetsSeparately(setCreatePayload, setUpdatePayload, setDeletePayload);

      const mechanicWebhookUrl = "https://webhooks.mechanic.dev/3a905cc4-b91b-4f3e-9584-3fa8d66fea76";

      const payload = {
        operation_id: operationId,
        stock_operations: stockOperations,
        updates: updates,
        orders_to_tag: pendingOrderTags.add,
        orders_to_untag: pendingOrderTags.remove,
        orders_to_update_samples: editsArray,
        order_state_patches: orderStatePatches,
        new_shop_metafield: null,
        buisjes_voorraad: buisjesChangedSave ? buisjesValueSave : null,
        complete_sets_create: [],
        complete_sets_update: [],
        complete_sets_delete: []
      };

      const response = await fetch(mechanicWebhookUrl, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });

      if (response.ok) {
        if (pendingTellingResults.length > 0) {
          await savePendingTellingResults();
        }

        loaderTitle.textContent = 'Verifiëren...';
        allRows.forEach(row => {
          const limitedToggle = row.querySelector('.limited-toggle');
          if (limitedToggle) limitedToggle.setAttribute('data-original', limitedToggle.checked.toString());
        });

        pollForUpdates(pollConditions, 0, sourceBtn);
        return true;
      } else {
        alert("Er ging iets mis bij het verzenden naar Shopify. Probeer het nog eens.");
        globalLoader.hidden = true; saveBtn.disabled = false; if (sourceBtn) sourceBtn.disabled = false; return false;
      }
    } catch(err) {
      alert("Fout bij het voorbereiden van de data: " + err.message);
      globalLoader.hidden = true; saveBtn.disabled = false; if (sourceBtn) sourceBtn.disabled = false; return false;
    }
  }

  async function pollForUpdates(condition, attempts = 0, sourceBtn = null) {
    if (attempts > 15) {
      loaderTitle.textContent = 'Duurt iets langer...';
      loaderText.textContent = 'Shopify reageert traag, pagina wordt voor de zekerheid herladen.';
      window.location.reload(true);
      return;
    }

    try {
      const res = await fetch(window.location.pathname + '?_t=' + Date.now());
      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const conditions = Array.isArray(condition) ? condition : (condition ? [condition] : []);
      const isUpdated = conditions.length === 0 || conditions.every(c => checkSinglePollCondition(c, doc));

      if (isUpdated) {
        loaderTitle.textContent = 'Voltooid!';
        loaderText.textContent = 'Data klopt met Shopify. Scherm wordt naadloos ververst...';

        tableBody.innerHTML = doc.getElementById('dashTableBody').innerHTML;

        const freshSetsBody   = doc.getElementById('setsManageBody');
        const currentSetsBody = document.getElementById('setsManageBody');
        if (freshSetsBody && currentSetsBody) {
          currentSetsBody.innerHTML = freshSetsBody.innerHTML;
          document.querySelectorAll('.sets-manage-row').forEach(function(row) {
            updateSetDeleteBtnState(row);
          });
        }
        pendingSetEdits   = {};
        pendingSetsCreate = [];
        pendingSetsDelete = [];

        document.querySelectorAll('.sets-manage-row').forEach(function(row) {
          const t = row.querySelector('.set-active-toggle');
          if (t) t.setAttribute('data-original', t.checked.toString());
          const o = row.querySelector('.set-order-input');
          if (o) o.setAttribute('data-original', o.value);
        });

        const freshBuisjesInp = doc.getElementById('buisjesVoorraadInput');
        const currentBuisjesInp = document.getElementById('buisjesVoorraadInput');
        if (freshBuisjesInp && currentBuisjesInp) {
          const newVal = freshBuisjesInp.getAttribute('data-original');
          currentBuisjesInp.setAttribute('data-original', newVal);
          currentBuisjesInp.value = newVal;
        }
        localOrders = getLocalOrdersFromDOM(doc);

        allRows = Array.from(document.querySelectorAll('.orn-dash__row'));
        allPerfumesList = allRows.map(row => {
          return {
            id: row.getAttribute('data-product-id'),
            name: row.querySelector('.orn-dash__td-name strong').textContent.trim(),
            vendor: row.querySelector('.orn-dash__vendor').textContent.trim(),
            image: row.getAttribute('data-image') || '',
            searchKey: row.getAttribute('data-search'),
            premium: row.getAttribute('data-premium') === 'true',
            rowElement: row
          };
        });

        renderOrders();
        calculateReservations();
        updateAnalyticsTable();
        calculateRecommendedStock();
        applyFiltersAndPaginate();

        pendingOrderTags = { add: [], remove: [] };
        pendingOrderSampleEdits = {};
        pendingOrderSampleEditsOriginal = {};
        pendingGratisSampleStateChecks = [];
        checkUnsavedChanges();

        setTimeout(() => {
            globalLoader.hidden = true;
            if(sourceBtn) sourceBtn.disabled = false;
        }, 600);

      } else {
        loaderText.textContent = `Wachten op Shopify database... (Poging ${attempts + 1}/15)`;
        setTimeout(() => pollForUpdates(condition, attempts + 1, sourceBtn), 2000);
      }
    } catch (e) {
      setTimeout(() => pollForUpdates(condition, attempts + 1, sourceBtn), 2000);
    }
  }

function updateBuisjesProjection() {
  const buisjesInp = document.getElementById('buisjesVoorraadInput');
  if (!buisjesInp) return;

  const buisjesOriginal = parseInt(buisjesInp.getAttribute('data-original'), 10) || 0;

  let totalIncrease = 0;
  allRows.forEach(row => {
    const stockInput = row.querySelector('.stock-input');
    const original = parseInt(stockInput.getAttribute('data-original'), 10) || 0;
    const current = parseInt(stockInput.value, 10) || 0;
    const diff = current - original;
    if (diff > 0) totalIncrease += diff;
  });

  buisjesInp.value = buisjesOriginal - totalIncrease;

  const noteEl = document.getElementById('buisjesProjectionNote');
  const noteText = document.getElementById('buisjesProjectionText');
  if (noteEl && noteText) {
    if (totalIncrease > 0) {
      noteText.textContent = `Automatisch −${totalIncrease} door voorraad ophogingen`;
      noteEl.hidden = false;
    } else {
      noteEl.hidden = true;
    }
  }

  updateBuisjesAnalytics();
}

function updateBuisjesAnalytics() {
  const activeBtn = document.querySelector('.orn-buisjes-filter-btn.is-active');
  const days = activeBtn ? activeBtn.getAttribute('data-days') : '90';
  const daysNum = parseInt(days, 10);

  let total = 0;
  document.querySelectorAll('.analytics-row').forEach(row => {
    total += parseInt(row.getAttribute('data-t' + days), 10) || 0;
  });

const avgDay = daysNum > 0 ? total / daysNum : 0;
const avgWeek = avgDay * 7;

let total90 = 0;
document.querySelectorAll('.analytics-row').forEach(row => {
  total90 += parseInt(row.getAttribute('data-t90'), 10) || 0;
});
const avgDay90 = total90 > 0 ? total90 / 90 : 0;

const buisjesInp = document.getElementById('buisjesVoorraadInput');
const currentBuisjes = buisjesInp ? (parseInt(buisjesInp.value, 10) || 0) : 0;
const dagenTotLeeg = avgDay90 > 0 ? Math.round(currentBuisjes / avgDay90) : null;

  const totaalEl = document.getElementById('buisjesTotaalVerkocht');
  const dagEl = document.getElementById('buisjesGemDag');
  const weekEl = document.getElementById('buisjesGemWeek');
  const leegEl = document.getElementById('buisjesDagenTotLeeg');
  const periodeEl = document.getElementById('buisjePeriodeLabel');

  if (totaalEl) totaalEl.textContent = total;
  if (dagEl) dagEl.textContent = avgDay.toFixed(1);
  if (weekEl) weekEl.textContent = avgWeek.toFixed(1);
  if (periodeEl) periodeEl.textContent = days === '1' ? '(24u)' : `(${days}d)`;

  if (leegEl) {
    if (dagenTotLeeg !== null) {
      let color = 'var(--dash-green)';
      if (dagenTotLeeg <= 7) color = 'var(--dash-red)';
      else if (dagenTotLeeg <= 21) color = 'var(--dash-orange)';
      leegEl.textContent = dagenTotLeeg + ' dgn';
      leegEl.style.color = color;
    } else {
      leegEl.textContent = '—';
      leegEl.style.color = '#9ca3af';
    }
  }
}

  saveBtn.addEventListener('click', () => saveDashboardData());

  function renderPaginationNumbers(currentPage, totalPages) {
    paginationNumbersContainer.innerHTML = '';
    if (totalPages <= 1) return;

    let pages = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 4) {
        pages = [1, 2, 3, 4, 5, '...', totalPages];
      } else if (currentPage >= totalPages - 3) {
        pages = [1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
      } else {
        pages = [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages];
      }
    }

    pages.forEach(p => {
      if (p === '...') {
        const span = document.createElement('span');
        span.className = 'pagination-ellipsis';
        span.textContent = '...';
        paginationNumbersContainer.appendChild(span);
      } else {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = `pagination-num-btn ${p === currentPage ? 'is-active' : ''}`;
        btn.textContent = p;
        btn.addEventListener('click', () => applyFiltersAndPaginate(p));
        paginationNumbersContainer.appendChild(btn);
      }
    });
  }

  function applyFiltersAndPaginate(page=1) {
    const query = searchInput.value.toLowerCase().trim();

    const activeBtns = Array.from(filterBtns).filter(btn => btn.classList.contains('is-active'));
    const statusFilters = activeBtns.map(btn => btn.getAttribute('data-status')).filter(s => s.startsWith('status-'));
    const attributeFilters = activeBtns.map(btn => btn.getAttribute('data-status')).filter(s => !s.startsWith('status-'));

    filteredRows = allRows.filter(row => {
      const searchText = row.getAttribute('data-search');
      const matchesSearch = searchText.includes(query);

      const matchesStatus = statusFilters.length === 0 || statusFilters.some(status => row.classList.contains(status));
      const matchesAttributes = attributeFilters.length === 0 || attributeFilters.every(attr => row.classList.contains(attr));

      return matchesSearch && matchesStatus && matchesAttributes;
    });

    allRows.forEach(row => row.style.display = 'none');
    filteredRows.forEach(row => row.style.display = '');
  }

const searchClearBtn = document.getElementById('dashSearchClear');

  searchInput.addEventListener('input', () => {
    if (searchClearBtn) {
      searchClearBtn.style.display = searchInput.value.length > 0 ? 'block' : 'none';
    }
    applyFiltersAndPaginate(1);
  });

  if (searchClearBtn) {
    searchClearBtn.addEventListener('click', () => {
      searchInput.value = '';                     // Maak het veld leeg
      searchClearBtn.style.display = 'none';      // Verberg het kruisje weer
      applyFiltersAndPaginate(1);                 // Reset de tabel
      searchInput.focus();                        // Zet de cursor terug in het veld
    });
  }
  filterBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      this.classList.toggle('is-active');
      applyFiltersAndPaginate(1);
    });
  });

  function applyOrderFilters() {
    const orderSearchInput = document.getElementById('orderSearch');
    const q = orderSearchInput ? orderSearchInput.value.toLowerCase().trim() : '';
    const activeBtns = document.querySelectorAll('.orn-order-filter-btn.is-active');
    const activeFilters = Array.from(activeBtns).map(btn => btn.getAttribute('data-filter'));

    const cards = document.querySelectorAll('.orn-dash__order-card');

    cards.forEach(card => {
      const searchText = card.getAttribute('data-search') || '';
      const status = card.getAttribute('data-status');
      const service = card.getAttribute('data-service');

      const matchesSearch = searchText.includes(q);

      let matchesFilter = true;
      if (activeFilters.length > 0) {
        const hasStatusFilter = activeFilters.includes('afgeschreven');
        const serviceFilters = activeFilters.filter(f => f !== 'afgeschreven');

        let statusMatch = true;
        if(hasStatusFilter) { statusMatch = (status === 'afgeschreven'); }

        let serviceMatch = true;
        if(serviceFilters.length > 0) {
          const cardServices = (service || '').split(' ').filter(Boolean);
          serviceMatch = serviceFilters.some(filter => cardServices.includes(filter));
        }

        matchesFilter = statusMatch && serviceMatch;
      }
      card.style.display = (matchesSearch && matchesFilter) ? '' : 'none';
    });
  }

  const orderSearchInput = document.getElementById('orderSearch');
  if(orderSearchInput) orderSearchInput.addEventListener('input', applyOrderFilters);

  const orderFilterBtns = document.querySelectorAll('.orn-order-filter-btn');
  orderFilterBtns.forEach(btn => {
      btn.addEventListener('click', function() {
          this.classList.toggle('is-active');
          applyOrderFilters();
      });
  });

  document.addEventListener('click', function(e) {
    const badge = e.target.closest('.orn-dash__reserved-badge');
    const pop = e.target.closest('#ornReservationPopover');

    if (pop) return;

    if (!badge || badge.hidden) {
      hideReservationPopover();
      return;
    }

    const productId = badge.getAttribute('data-reserved-id') || badge.closest('.orn-dash__row')?.getAttribute('data-product-id') || '';
    showReservationPopover(badge, productId);
  });

  window.addEventListener('resize', hideReservationPopover);
  window.addEventListener('scroll', hideReservationPopover, true);

  const modal = document.getElementById('ornModal');
  const modalClose = document.getElementById('ornModalClose');
  const modalCancel = document.getElementById('ornModalCancel');
  const modalBackdrop = document.getElementById('ornModalBackdrop');
  const modalSearch = document.getElementById('modalSearch');
  const modalGrid = document.getElementById('modalGrid');
  const modalSave = document.getElementById('ornModalSave');
  const modalCounter = document.getElementById('modalSelectedCount');

  const modalSelectionView = document.getElementById('modalSelectionView');
  const modalConfirmView = document.getElementById('modalConfirmView');
  const modalFooterStandard = document.getElementById('modalFooterStandard');
  const modalFooterConfirm = document.getElementById('modalFooterConfirm');
  const modalFooterCounter = document.getElementById('modalFooterCounter');
  const modalConfirmCount = document.getElementById('modalConfirmCount');
  const modalCancelConfirm = document.getElementById('ornModalCancelConfirm');
  const modalFinalDeduct = document.getElementById('ornModalFinalDeduct');

  const btnManualDeduct = document.getElementById('btnManualDeduct');
  if (btnManualDeduct) {
    btnManualDeduct.addEventListener('click', () => {
      isManualMode = true;
      currentEditOrderId = null;
      currentEditSetIndex = 0;
      modalSelectedSamples = [];
      modalSelectedSampleIds = [];
      document.getElementById('modalOrderName').textContent = 'Zelf een sample set samenstellen en afschrijven';
      const noteEl = document.getElementById('modalOrderNote');
      if(noteEl) noteEl.style.display = 'none';
      modalSearch.value = '';
      resetModalViews();
      renderModalGrid();
      modal.hidden = false;
    });
  }

  function openModal(orderId, setIndex = 0) {
    isManualMode = false;
    currentEditOrderId = orderId;
    currentEditSetIndex = parseInt(setIndex, 10) || 0;
    const order = localOrders.find(o => o.id.toString() === orderId);
    if (!order) return;

    let titleStr = "Bestelling: " + order.name;
    if (order.sets && order.sets.length > 1) {
        titleStr += " (Set " + (currentEditSetIndex + 1) + ")";
    }
    document.getElementById('modalOrderName').textContent = titleStr;

    modalSelectedSamples = [];
    modalSelectedSampleIds = [];

    let editKey = orderId + '-' + currentEditSetIndex;
    let setData = (order.sets && order.sets[currentEditSetIndex]) ? order.sets[currentEditSetIndex] : null;
    let samplesSource = pendingOrderSampleEdits[editKey]
      ? pendingOrderSampleEdits[editKey].map(name => ({ name: name, id: '', fromId: false }))
      : (setData ? getDisplayItemsForOrderSet(setData) : []);

    if (samplesSource) {
      samplesSource.forEach(item => {
        const s = typeof item === 'string' ? item : item.name;
        const id = typeof item === 'string' ? '' : item.id;
        let matchedPerfume = id ? findPerfumeByProductId(id) : null;

        if (!matchedPerfume && s) {
          let cleanInput = s.replace(/"/g, '').trim().toLowerCase();
          matchedPerfume = allPerfumesList.find(p => p.name.toLowerCase() === cleanInput || cleanInput.includes(p.name.toLowerCase()));
        }

        if (matchedPerfume && !modalSelectedSampleIds.includes(matchedPerfume.id)) {
          modalSelectedSamples.push(matchedPerfume.name);
          modalSelectedSampleIds.push(matchedPerfume.id);
        }
      });
    }

    modalSearch.value = '';
    resetModalViews();
    renderModalGrid();
    modal.hidden = false;
  }

  function renderModalContextInfo() {
    const noteEl = document.getElementById('modalOrderNote');
    if (!noteEl) return;

    if (isManualMode || !currentEditOrderId || currentEditSetIndex < 0) {
      noteEl.style.display = 'none';
      noteEl.innerHTML = '';
      return;
    }

    const order = localOrders.find(item => String(item.id) === String(currentEditOrderId));
    const set = order && Array.isArray(order.sets) ? order.sets[currentEditSetIndex] : null;
    const premiumBought = getOrderSetPremiumCount(set);
    const premiumSelected = getPremiumSelectionCount(modalSelectedSampleIds);
    const blocks = [];

    if (order && order.note) {
      blocks.push(`<div><strong>Notitie / Wensen:</strong> ${order.note}</div>`);
    }

    if (premiumBought > 0) {
      const stateClass = premiumSelected === premiumBought
        ? ' is-complete'
        : (premiumSelected > premiumBought ? ' is-over' : '');
      blocks.push(`<div class="orn-dash__modal-premium-summary${stateClass}"><strong>Premium:</strong> ${premiumBought} gekocht · ${premiumSelected}/${premiumBought} geselecteerd</div>`);
    }

    noteEl.innerHTML = blocks.join('');
    noteEl.style.display = blocks.length > 0 ? 'block' : 'none';
  }

  function resetModalViews() {
      modalSelectionView.hidden = false;
      modalFooterStandard.hidden = false;
      modalFooterCounter.hidden = false;
      modalConfirmView.hidden = true;
      modalFooterConfirm.hidden = true;
  }

  function closeModal() { modal.hidden = true; currentEditOrderId = null; currentEditSetIndex = 0; isManualMode = false; }
  modalClose.addEventListener('click', closeModal);
  modalCancel.addEventListener('click', closeModal);
  modalBackdrop.addEventListener('click', closeModal);
  modalSearch.addEventListener('input', renderModalGrid);

  if (modalCancelConfirm) {
      modalCancelConfirm.addEventListener('click', resetModalViews);
  }

  function renderModalGrid() {
    const q = modalSearch.value.toLowerCase().trim();
    let html = '';

    const maxReached = modalSelectedSampleIds.length >= 5;

    allPerfumesList.forEach(perfume => {
      if (perfume.searchKey.includes(q)) {
        const isSelected = modalSelectedSampleIds.includes(perfume.id);

        const isOnline = perfume.rowElement.querySelector('.online-toggle').checked;
        const isExclusive = perfume.rowElement.querySelector('.exclusive-toggle').checked;

        const disabledClass = (maxReached && !isSelected) ? ' is-disabled' : '';
        const tileClass = isSelected ? 'orn-modal-tile is-selected' : 'orn-modal-tile';

        const imgHtml = perfume.image ? `<img src="${perfume.image}" class="orn-modal-tile-img" alt="${perfume.name}">` : `<div class="orn-modal-tile-img" style="background:#f3f4f6;"></div>`;

        let oosLabel = '';
        if (isExclusive) {
            oosLabel = `<div style="color:var(--dash-dark); font-size:9px; font-weight:700; text-transform:uppercase; margin-top:4px; padding:2px 4px; background:#e5e7eb; border-radius:4px; display:inline-block;">Store Exclusive</div>`;
        } else if (!isOnline) {
            oosLabel = `<div style="color:var(--dash-red); font-size:9px; font-weight:700; text-transform:uppercase; margin-top:4px;">Niet beschikbaar</div>`;
        }
        const premiumLabel = isPerfumePremium(perfume)
          ? `<div class="orn-dash__premium-tile-label">Premium · +€2</div>`
          : '';

        html += `
          <div class="${tileClass}${disabledClass} order-sample-tile" data-name="${perfume.name.replace(/"/g, '&quot;')}" data-product-id="${perfume.id}" style="cursor:pointer;">
            <div class="orn-modal-check"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><polyline points="20 6 9 17 4 12"></polyline></svg></div>
            ${imgHtml}
            <div style="margin-top:auto;">
               <div class="orn-modal-tile-name">${perfume.name}</div>
               <div class="orn-modal-tile-vendor">${perfume.vendor}</div>
               ${premiumLabel}
               ${oosLabel}
            </div>
          </div>
        `;
      }
    });
    modalGrid.innerHTML = html;
    modalCounter.textContent = modalSelectedSampleIds.length;
    renderModalContextInfo();

    const modalSelectedNames = document.getElementById('modalSelectedNames');
    if (modalSelectedNames) {
      if (modalSelectedSamples.length === 0) {
        modalSelectedNames.innerHTML = '<span style="color: #9ca3af; font-size: 12px; font-style: italic;">Nog geen geuren geselecteerd...</span>';
      } else {
        modalSelectedNames.innerHTML = modalSelectedSamples.map((name, index) =>
          `<span class="orn-dash__sample-pill" style="background: #ffffff; border-color: #d1d5db;">${name}${isPerfumePremium(allPerfumesList.find(item => String(item.id) === String(modalSelectedSampleIds[index]))) ? '<span class="orn-dash__premium-pill-mark">Premium</span>' : ''}</span>`
        ).join('');
      }
    }
  }

  if (modalGrid) {
      modalGrid.addEventListener('click', function(e) {
          const tile = e.target.closest('.order-sample-tile');
          if (tile) {
              const name = tile.getAttribute('data-name');
              const productId = tile.getAttribute('data-product-id');
              const index = modalSelectedSampleIds.indexOf(productId);

              if (index > -1) {
                modalSelectedSampleIds.splice(index, 1);
                modalSelectedSamples.splice(index, 1);
              } else if (modalSelectedSampleIds.length < 5) {
                modalSelectedSampleIds.push(productId);
                modalSelectedSamples.push(name);
              }
              renderModalGrid();
          }
      });
  }

  modalSave.addEventListener('click', function() {
    if (isManualMode) {
      if (modalSelectedSamples.length === 0) {
        alert("Selecteer minimaal 1 sample om af te schrijven.");
        return;
      }

      modalSelectionView.hidden = true;
      modalFooterStandard.hidden = true;
      modalFooterCounter.hidden = true;

      modalConfirmCount.textContent = modalSelectedSamples.length;
      modalConfirmView.hidden = false;
      modalFooterConfirm.hidden = false;
    }
else {
      if (!currentEditOrderId) return;
        if (currentEditSetIndex === -1) {
        const gsIdx = localOrders.findIndex(o => o.id.toString() === currentEditOrderId);
        if (gsIdx > -1 && modalSelectedSampleIds.length > 0) {
          const selectedId = modalSelectedSampleIds[0];
          const matchedPerfume = allPerfumesList.find(p => p.id === selectedId);
          if (!matchedPerfume) {
            alert("De gekozen gratis sample heeft geen geldige product-ID.");
            return;
          }
          const selectedName = matchedPerfume.name;

          if (!localOrders[gsIdx].gratis_samples || !Array.isArray(localOrders[gsIdx].gratis_samples)) {
            localOrders[gsIdx].gratis_samples = getGratisSamplesArray(localOrders[gsIdx]);
          }

          const sIdx = currentEditGratisSampleIdx;
          if (localOrders[gsIdx].gratis_samples[sIdx]) {
            localOrders[gsIdx].gratis_samples[sIdx].sample = 'Andere sample: ' + selectedName;
            localOrders[gsIdx].gratis_samples[sIdx].sample_id = matchedPerfume.id;
          }

          if (sIdx === 0) {
            localOrders[gsIdx].gratis_sample = 'Andere sample: ' + selectedName;
            localOrders[gsIdx].gratis_sample_id = matchedPerfume.id;
          }

          pendingOrderSampleEdits[`${currentEditOrderId}-gratis-${sIdx}`] = [selectedName];
          renderOrders();
          calculateReservations();
          checkUnsavedChanges();
          saveDashboardData(modalSave);
        }
        closeModal();
        return;
      } else {
        saveEditedOrderSamples();
      }
    }
  });

  function saveEditedOrderSamples() {
      const orderIndex = localOrders.findIndex(o => o.id.toString() === currentEditOrderId);
      if (orderIndex > -1) {
        if (!localOrders[orderIndex].sets) localOrders[orderIndex].sets = [{}];
        if (!localOrders[orderIndex].sets[currentEditSetIndex]) localOrders[orderIndex].sets[currentEditSetIndex] = {};

        let originalSamples = localOrders[orderIndex].sets[currentEditSetIndex].samples || [];
        let editKey = currentEditOrderId + '-' + currentEditSetIndex;
        if (!pendingOrderSampleEditsOriginal[editKey]) {
          pendingOrderSampleEditsOriginal[editKey] = originalSamples.filter(s => {
            if (s.trim() === "" || s.trim() === "-") return false;
            let cleanS = s.toLowerCase().replace(/[^a-z0-9]/g, '');
            return allPerfumesList.some(p => p.name.toLowerCase().replace(/[^a-z0-9]/g, '') === cleanS);
          });
        }
        const currentSetOption = (localOrders[orderIndex].sets[currentEditSetIndex].option || '').toLowerCase();
        let preservedNotes = currentSetOption.includes('complete')
          ? []
          : originalSamples.filter(s => {
              if(s.trim() === "" || s.trim() === "-") return false;
              let cleanS = s.toLowerCase().replace(/[^a-z0-9]/g, '');
              let isReal = allPerfumesList.some(p => p.name.toLowerCase().replace(/[^a-z0-9]/g, '') === cleanS);
              return !isReal;
            });

        localOrders[orderIndex].sets[currentEditSetIndex].samples = [...preservedNotes, ...modalSelectedSamples];
        localOrders[orderIndex].sets[currentEditSetIndex].sample_ids = [
          ...preservedNotes.map(() => ''),
          ...modalSelectedSampleIds
        ];

        pendingOrderSampleEdits[editKey] = [...modalSelectedSamples];

        orderSampleEditLog[editKey] = {
          orig: (pendingOrderSampleEditsOriginal[editKey] || []).join(', ') || 'Geen',
          nieuw: [...modalSelectedSamples].join(', ') || 'Geen'
        };

        if (!localOrders[orderIndex].sample_edits) localOrders[orderIndex].sample_edits = {};
        localOrders[orderIndex].sample_edits[currentEditSetIndex] = {
          orig: orderSampleEditLog[editKey].orig,
          nieuw: orderSampleEditLog[editKey].nieuw,
          ts: new Date().toLocaleDateString('nl-NL')
        };

        renderOrders();
        calculateReservations();
        checkUnsavedChanges();

        saveDashboardData(modalSave);
      }
      closeModal();
  }

  if (modalFinalDeduct) {
      modalFinalDeduct.addEventListener('click', async function() {
        if (!isManualMode) return;

        if (modalSelectedSampleIds.length === 0) {
          alert("Selecteer minimaal 1 sample om af te schrijven.");
          return;
        }

        const selectedRows = modalSelectedSampleIds.map(productId =>
          allRows.find(r => r.getAttribute('data-product-id').toString() === productId.toString())
        );

        if (selectedRows.some(row => !row)) {
          alert("Afschrijven is gestopt: minimaal één geselecteerde sample heeft geen geldige product-ID.");
          return;
        }

        selectedRows.forEach(row => {
          const stockInput = row.querySelector('.stock-input');
          let currentVal = parseInt(stockInput.value, 10) || 0;
          stockInput.value = currentVal - 1;
          updateRowUI(row, true);
        });

        checkUnsavedChanges();
        await saveDashboardData(modalFinalDeduct);
        closeModal();
      });
  }

  function normalizeProductIdForCompare(id) {
    return String(id || '').replace('gid://shopify/Product/', '').trim();
  }

  function findPerfumeByProductId(id) {
    const cleanId = normalizeProductIdForCompare(id);
    if (!cleanId) return null;
    return allPerfumesList.find(p => normalizeProductIdForCompare(p.id) === cleanId) || null;
  }

  function getDisplayItemsForOrderSet(set) {
    const rawSamples = Array.isArray(set?.samples) ? set.samples : [];
    const rawIds = Array.isArray(set?.sample_ids) ? set.sample_ids : [];
    const maxLen = Math.max(rawSamples.length, rawIds.length);
    const items = [];
    const seenIds = new Set();
    const seenNames = new Set();

    for (let i = 0; i < maxLen; i++) {
      const rawId = rawIds[i] || '';
      const cleanId = normalizeProductIdForCompare(rawId);
      const matchedById = findPerfumeByProductId(rawId);

      if (matchedById) {
        const idKey = normalizeProductIdForCompare(matchedById.id);
        if (seenIds.has(idKey)) continue;
        seenIds.add(idKey);
        seenNames.add(matchedById.name.toLowerCase().trim());
        items.push({ name: matchedById.name, id: matchedById.id, fromId: true });
        continue;
      }

      const rawName = rawSamples[i];
      if (typeof rawName === 'string' && rawName.trim() !== '') {
        if (isLegacyPremiumMetadataText(rawName)) continue;
        const nameKey = rawName.toLowerCase().trim();
        if (seenNames.has(nameKey)) continue;
        if (cleanId && seenIds.has(cleanId)) continue;
        seenNames.add(nameKey);
        if (cleanId) seenIds.add(cleanId);
        items.push({ name: rawName, id: '', fromId: false });
      }
    }

    return items;
  }

  function extractCompleteSetName(set) {
    const samples = Array.isArray(set?.samples) ? set.samples : [];
    const candidates = samples.filter(s => typeof s === 'string' && s.trim() !== '');

    for (const value of candidates) {
      let text = value.trim();
      const lower = text.toLowerCase();

      if (lower.startsWith('custom set:')) {
        text = text.substring(11).trim();
      } else if (lower.startsWith('set:')) {
        text = text.substring(4).trim();
      } else {
        continue;
      }

      const parenIndex = text.indexOf('(');
      if (parenIndex > -1) text = text.substring(0, parenIndex).trim();
      return text;
    }

    return '';
  }

  function getOrderSetOptionLabel(set) {
    const option = set?.option || '';
    const optLower = option.toLowerCase();

    if (optLower.includes('complete')) {
      const setName = extractCompleteSetName(set);
      return setName ? `${option}: ${setName}` : option;
    }

    return option;
  }

  const ordersList = document.getElementById('dashOrdersList');

function formatRfmGroupName(value) {
  const raw = (value || '').toString().trim();
  if (!raw) return 'Onbekend';

  const labels = {
    ACTIVE: 'Active',
    ALMOST_LOST: 'Almost lost',
    AT_RISK: 'At risk',
    CHAMPIONS: 'Champions',
    DORMANT: 'Dormant',
    LOYAL: 'Loyal',
    NEEDS_ATTENTION: 'Needs attention',
    NEW: 'New',
    PREVIOUSLY_LOYAL: 'Previously loyal',
    PROMISING: 'Promising',
    PROSPECTS: 'Prospects'
  };

  return labels[raw] || raw.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
}

function formatCustomerSpent(order) {
  const amount = Number(order?.customer_total_spent || 0);
  const currency = order?.customer_total_spent_currency || 'EUR';

  try {
    return new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  } catch (e) {
    return `€${amount.toFixed(2).replace('.', ',')}`;
  }
}

function formatCustomerLine(order) {
  const name = order?.customer || 'Onbekende klant';
  const orderCount = Number(order?.customer_order_count || 0);
  const spent = formatCustomerSpent(order);
  const rfmGroup = formatRfmGroupName(order?.customer_rfm_group);

  return `${name} | Orders: ${orderCount} | Besteed: ${spent} | Groep: ${rfmGroup}`;
}

function ornDashEscapeHtml(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

function getOpenOrderCustomerKey(order) {
  const candidates = [
    order?.customer_id,
    order?.customer_email,
    order?.email,
    order?.customer,
    order?.customer_name
  ];

  const value = candidates.find(v => v !== undefined && v !== null && String(v).trim() !== '');
  return value ? String(value).trim().toLowerCase().replace(/\s+/g, ' ') : '';
}

function buildOpenOrderCustomerGroups(orders) {
  const groups = {};

  (orders || []).forEach(order => {
    if (!order || isWholeOrderHandled(order)) return;

    const key = getOpenOrderCustomerKey(order);
    if (!key) return;

    if (!groups[key]) groups[key] = [];
    groups[key].push(order);
  });

  return groups;
}

function getOpenOrderShippingAddress(order) {
  return order?.shipping_address
    || order?.shippingAddress
    || order?.delivery_address
    || order?.deliveryAddress
    || null;
}

function getOpenOrderAddressField(address, ...keys) {
  if (!address) return '';

  for (const key of keys) {
    const value = address[key];
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      return String(value).trim();
    }
  }

  return '';
}

function normalizeOpenOrderAddressPart(value) {
  let normalized = String(value ?? '').trim().toLowerCase();

  if (typeof normalized.normalize === 'function') {
    normalized = normalized.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
  }

  return normalized
    .replace(/ß/g, 'ss')
    .replace(/[^a-z0-9]/g, '');
}

function getOpenOrderAddressKey(order) {
  const address = getOpenOrderShippingAddress(order);
  if (!address) return '';

  const address1 = getOpenOrderAddressField(address, 'address1', 'address_1');
  const address2 = getOpenOrderAddressField(address, 'address2', 'address_2');
  const zip = getOpenOrderAddressField(address, 'zip', 'postal_code', 'postalCode');
  const city = getOpenOrderAddressField(address, 'city');
  const country = getOpenOrderAddressField(
    address,
    'country_code',
    'countryCodeV2',
    'country_code_v2',
    'countryCode',
    'country'
  );

  // Zonder straat of plaats/postcode is er te weinig informatie om adressen
  // betrouwbaar gelijk of verschillend te noemen.
  if (!address1 || (!zip && !city)) return '';

  return [address1, address2, zip, city, country]
    .map(normalizeOpenOrderAddressPart)
    .join('|');
}

function formatOpenOrderAddress(order) {
  const address = getOpenOrderShippingAddress(order);
  if (!address) return 'Adres niet beschikbaar';

  const name = getOpenOrderAddressField(address, 'name');
  const company = getOpenOrderAddressField(address, 'company');
  const address1 = getOpenOrderAddressField(address, 'address1', 'address_1');
  const address2 = getOpenOrderAddressField(address, 'address2', 'address_2');
  const zip = getOpenOrderAddressField(address, 'zip', 'postal_code', 'postalCode');
  const city = getOpenOrderAddressField(address, 'city');
  const country = getOpenOrderAddressField(address, 'country', 'country_code', 'countryCodeV2');
  const cityLine = [zip, city].filter(Boolean).join(' ');
  const parts = [name, company, address1, address2, cityLine, country].filter(Boolean);

  return parts.length > 0 ? parts.join(', ') : 'Adres niet beschikbaar';
}

function classifyOpenOrderAddresses(orders) {
  const addressKeys = (orders || []).map(getOpenOrderAddressKey);

  if (addressKeys.some(key => !key)) {
    return {
      type: 'unknown',
      className: 'is-address-unknown',
      label: 'adrescontrole onvolledig'
    };
  }

  const uniqueAddressCount = new Set(addressKeys).size;

  if (uniqueAddressCount === 1) {
    return {
      type: 'same',
      className: 'is-same-address',
      label: 'zelfde adres'
    };
  }

  if (uniqueAddressCount === addressKeys.length) {
    return {
      type: 'different',
      className: 'is-different-address',
      label: 'verschillende adressen'
    };
  }

  return {
    type: 'mixed',
    className: 'is-mixed-address',
    label: 'mix van adressen'
  };
}

function getMultiOpenOrdersNoticeHtml(order, openOrderCustomerGroups) {
  const key = getOpenOrderCustomerKey(order);
  const matches = key ? (openOrderCustomerGroups[key] || []) : [];

  if (matches.length <= 1) return '';

  const addressStatus = classifyOpenOrderAddresses(matches);
  const addressOverview = matches
    .map(o => `${o?.name || 'Bestelling'} — ${formatOpenOrderAddress(o)}`)
    .join('\n');

  return `<div class="orn-dash__multi-order-alert ${addressStatus.className}" title="${ornDashEscapeHtml(addressOverview)}">
    <span class="orn-dash__multi-order-dot"></span>
    ${matches.length} open bestellingen · ${addressStatus.label}
  </div>`;
}

function renderOrders() {
    if(!localOrders || localOrders.length === 0) {
      ordersList.innerHTML = '<p class="remake-empty-msg">Geen openstaande bestellingen.</p>';
      const countEl = document.getElementById('openOrdersCount');
      if (countEl) countEl.textContent = '';
      return;
    }

    localOrders.sort((a, b) => (isWholeOrderHandled(a) === isWholeOrderHandled(b)) ? 0 : isWholeOrderHandled(a) ? 1 : -1);

    const openCount = localOrders.filter(o => !isWholeOrderHandled(o)).length;
    const countEl = document.getElementById('openOrdersCount');
    if (countEl) {
      countEl.textContent = openCount > 0 ? `(${openCount})` : '';
    }

    const openOrderCustomerGroups = buildOpenOrderCustomerGroups(localOrders);

    let html = '';
    let orderCounts = {
      'verras-me': 0,
      'door-ornata': 0,
      'complete-sets': 0,
      'zelf-samenstellen': 0,
      'gratis-sample': 0
    };

    localOrders.forEach(order => {
      let serviceTypeAttr = '';
      let orderServiceTypes = [];
      const addOrderServiceType = (type) => {
        if (type && !orderServiceTypes.includes(type)) orderServiceTypes.push(type);
      };
      const orderGratisSamples = getGratisSamplesArray(order);
      const orderHasSets = hasSetContent(order);
      const orderHasGratis = orderGratisSamples.length > 0;
      const isMixedOrderCard = orderHasSets && orderHasGratis;
      const multiOpenOrdersNoticeHtml = getMultiOpenOrdersNoticeHtml(order, openOrderCustomerGroups);

      if (!orderHasSets && orderHasGratis) {
  serviceTypeAttr = 'gratis-sample';

  const samples = getGratisSamplesArray(order);
  const allHandled = allGratisSamplesHandled(samples);
  const anyHandled = anyGratisSampleHandled(samples);
  const handledCount = samples.filter(s => s.deducted || s.no_deduct).length;
  const deductedCount = samples.filter(s => s.deducted).length;
  const noDeductCount = samples.filter(s => s.no_deduct).length;

  if (!allHandled) orderCounts['gratis-sample']++;

  let gsStatusClass, gsStatusText;
  if (allHandled) {
    gsStatusClass = 'status-done';
    if (noDeductCount === samples.length) gsStatusText = 'Geen afschrijving';
    else if (noDeductCount > 0) gsStatusText = 'Verwerkt';
    else gsStatusText = 'Afgeschreven';
  } else if (anyHandled && samples.length > 1) {
    gsStatusClass = 'status-pending'; gsStatusText = `${handledCount}/${samples.length} verwerkt`;
  } else {
    gsStatusClass = 'status-pending'; gsStatusText = 'Niet verwerkt';
  }

  const gsCardClass = allHandled ? 'is-deducted' : '';
  const gsStatusAttr = allHandled ? 'afgeschreven' : 'pending';
  const gsSearch = [
    order.name || '',
    order.customer || '',
    String(order.customer_order_count || ''),
    String(order.customer_total_spent || ''),
    formatCustomerSpent(order),
    formatRfmGroupName(order.customer_rfm_group),
    order.note || '',
    ...samples.flatMap(sample => [sample.product || '', sample.sample || ''])
  ].join(' ').toLowerCase().replace(/"/g, '&quot;');
  const gsNoteHtml = order.note
    ? `<div class="orn-dash__order-note"><strong>Notitie:</strong> ${order.note}</div>`
    : '';

  let samplesHtml = '';
  samples.forEach((sample, sIdx) => {
    const sHandled = sample.deducted || sample.no_deduct;
    const sStatusLabel = sample.deducted
      ? `<span style="font-size:10px;font-weight:700;color:var(--dash-green);white-space:nowrap;">✓ Afgeschreven</span>`
      : sample.no_deduct
        ? `<span style="font-size:10px;font-weight:700;color:#3b82f6;white-space:nowrap;">✓ Geen afschr.</span>`
        : '';

    const sDisplay = (sample.sample || '—')
      .replace(/^Andere sample:\s*/i, '')
      .replace(/^Sample van dit parfum\s*\(/i, '')
      .replace(/\)$/, '');

    const bgColor = sHandled ? 'var(--dash-bg)' : '#ffffff';
    const opacity = sHandled ? '0.65' : '1';

    samplesHtml += `
      <div class="orn-gs-sample-block" style="border:1px solid var(--dash-border);border-radius:6px;padding:10px;margin-bottom:8px;background:${bgColor};opacity:${opacity};">
        ${sample.product ? `<div style="font-size:10px;font-weight:700;color:#6b7280;text-transform:uppercase;letter-spacing:0.03em;margin-bottom:6px;">${sample.product}</div>` : ''}
        <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;flex-wrap:wrap;margin-bottom:6px;">
          <span class="orn-dash__sample-pill" data-samplename="${sDisplay.replace(/"/g,'&quot;')}" data-product-id="${sample.sample_id||''}">${sDisplay}</span>
          ${sStatusLabel}
        </div>
        <div id="gs-wrapper-actions-${order.id}-${sIdx}" style="display:flex;gap:6px;flex-wrap:wrap;">
          <button type="button" class="orn-btn-outline gratis-edit-btn"
            data-id="${order.id}" data-sample-idx="${sIdx}"
            style="flex:1;font-size:10px;padding:4px 8px;"
            ${sHandled ? 'disabled' : ''}>Bewerken</button>
          ${sHandled ? `
            <button type="button" class="gs-prompt-action-btn orn-btn-outline"
              data-action="${sample.deducted ? 'herstel' : 'reset-geen'}" data-id="${order.id}" data-sample-idx="${sIdx}"
              style="flex:1;font-size:10px;padding:4px 8px;color:var(--dash-orange);border-color:var(--dash-orange);">↩ Herstel</button>
          ` : `
            <button type="button" class="gs-prompt-action-btn orn-btn-solid"
              data-action="afschrijven" data-id="${order.id}" data-sample-idx="${sIdx}"
              style="flex:1;font-size:10px;padding:4px 8px;">− Afschr.</button>
            <button type="button" class="gs-prompt-action-btn orn-btn-outline"
              data-action="geen" data-id="${order.id}" data-sample-idx="${sIdx}"
              style="flex:1;font-size:10px;padding:4px 8px;">✓ Geen</button>
          `}
        </div>
        <div class="orn-dash__confirm-box" id="gs-confirm-${order.id}-${sIdx}" hidden style="margin-top:8px;">
          <p class="orn-dash__confirm-text" id="gs-confirm-text-${order.id}-${sIdx}"></p>
          <div class="orn-dash__confirm-actions">
            <button type="button" class="orn-btn-outline gs-cancel-action-btn"
              data-id="${order.id}" data-sample-idx="${sIdx}">Annuleren</button>
            <button type="button" class="orn-btn-solid gs-confirm-action-btn"
              data-id="${order.id}" data-sample-idx="${sIdx}"
              id="gs-confirm-btn-${order.id}-${sIdx}">Ja, opslaan</button>
          </div>
        </div>
      </div>
    `;
  });

  html += `
    <div class="orn-dash__order-card ${gsCardClass}" data-order-id="${order.id}" data-search="${gsSearch}" data-status="${gsStatusAttr}" data-service="gratis-sample">
      <div class="orn-dash__order-header">
        <div>
          <div class="orn-dash__order-number">${order.name}</div>
          <div class="orn-dash__order-customer">${formatCustomerLine(order)}</div>
          ${multiOpenOrdersNoticeHtml}
        </div>
        <span class="orn-dash__order-status ${gsStatusClass}">${gsStatusText}</span>
      </div>
      ${gsNoteHtml}
      <div class="orn-dash__order-set">
        <div class="orn-dash__set-title">Gratis samples:</div>
        ${samplesHtml}
      </div>
    </div>`;
  return;
}

      const setPartHandled = areSetSamplesHandled(order);
      const gratisPartHandled = areGratisSamplesHandled(order);
      const wholeOrderHandled = isWholeOrderHandled(order);
      const anyMixedPartHandled = isMixedOrderCard && (setPartHandled || anyGratisSampleHandled(orderGratisSamples));

      const statusClass = wholeOrderHandled ? 'status-done' : 'status-pending';
      const statusText = wholeOrderHandled
        ? (isMixedOrderCard && orderGratisSamples.some(s => s.no_deduct) ? 'Verwerkt' : 'Afgeschreven')
        : (anyMixedPartHandled ? 'Deels verwerkt' : 'Niet afgeschreven');
      const cardClass = wholeOrderHandled ? 'is-deducted' : '';

      let setsHtml = '';
      let isCompleteSetOrder = false;

      if(order.sets) {
        order.sets.forEach((set, index) => {
          let pills = '';
          let mappedPills = [];
          let isCompleteSet = false;
          let hasValidSamples = false;

          const optLower = (set.option || '').toLowerCase();
          if(optLower.includes('verras me')) {
              serviceTypeAttr = 'verras-me';
              addOrderServiceType('verras-me');
          }
          else if(optLower.includes('door ornata')) {
              serviceTypeAttr = 'door-ornata';
              addOrderServiceType('door-ornata');
          }
          else if(optLower.includes('complete')) {
              serviceTypeAttr = 'complete-sets';
              addOrderServiceType('complete-sets');
              isCompleteSet = true;
              isCompleteSetOrder = true;
          }
          else if(optLower.includes('zelf')) {
              serviceTypeAttr = 'zelf-samenstellen';
              addOrderServiceType('zelf-samenstellen');
          }

          const displayItems = getDisplayItemsForOrderSet(set);
          const hasOnlyPlaceholder = displayItems.length === 1 && displayItems[0].name === "Geen specifieke geuren doorgegeven";
          const premiumBought = getOrderSetPremiumCount(set);
          const premiumOrderNoteHtml = premiumBought > 0
            ? `<div class="orn-dash__premium-order-note"><span class="orn-dash__premium-order-dot"></span>${premiumBought} ${premiumBought === 1 ? 'premium sample' : 'premium samples'} gekocht</div>`
            : '';

          if(displayItems.length > 0 && !hasOnlyPlaceholder) {
            displayItems.forEach((item) => {
               const s = item.name || '';
               if (s.trim() === "" || s.trim() === "-") return;

               let s_id = item.id || '';

               let cleanS = s.toLowerCase().replace(/[^a-z0-9]/g, '');
               let isReal = false;

               let isPrefText = cleanS.includes('geurfamilies') || cleanS.includes('intensiteit') || cleanS.includes('notitie') || cleanS.startsWith('set') || cleanS.startsWith('customset');

               if(item.fromId) {
                 isReal = true;
               } else if(!isPrefText) {
                 isReal = allPerfumesList.some(p => {
                    let cleanP = p.name.toLowerCase().replace(/[^a-z0-9]/g, '');
                    if(cleanP.length < 3) return false;
                    return cleanS === cleanP;
                 });
               }

               if(isReal) {
                 hasValidSamples = true;
                 const matchedPremiumPerfume = s_id
                   ? findPerfumeByProductId(s_id)
                   : allPerfumesList.find(p => p.name.toLowerCase().replace(/[^a-z0-9]/g, '') === cleanS);
                 const premiumPillMark = isPerfumePremium(matchedPremiumPerfume)
                   ? '<span class="orn-dash__premium-pill-mark">Premium</span>'
                   : '';
                 mappedPills.push(`<span class="orn-dash__sample-pill" data-samplename="${s.replace(/"/g, '&quot;')}" data-product-id="${s_id}">${s}${premiumPillMark}</span>`);
               } else {
                 let prefHtml = `<div class="orn-dash__order-pref"><strong>Voorkeur:</strong> ${s}</div>`;
                 let sLower = s.toLowerCase();

                 if (sLower.startsWith("geurfamilies:")) {
                     prefHtml = `<div class="orn-dash__order-pref"><strong>Geurfamilies:</strong> ${s.substring(13).trim()}</div>`;
                 } else if (sLower.startsWith("intensiteit:")) {
                     prefHtml = `<div class="orn-dash__order-pref"><strong>Intensiteit:</strong> ${s.substring(12).trim()}</div>`;
                 } else if (sLower.startsWith("notities:")) {
                     prefHtml = `<div class="orn-dash__order-pref"><strong>Notities:</strong> ${s.substring(9).trim()}</div>`;
                 } else if (sLower.startsWith("notitie:")) {
                     prefHtml = `<div class="orn-dash__order-pref"><strong>Notitie:</strong> ${s.substring(8).trim()}</div>`;
                 } else if (sLower.startsWith("set:")) {
                     prefHtml = `<div class="orn-dash__order-pref"><strong>Set:</strong> ${s.substring(4).trim()}</div>`;
                 } else if (sLower.startsWith("custom set:")) {
                     prefHtml = `<div class="orn-dash__order-pref"><strong>Set:</strong> ${s.substring(11).trim()}</div>`;
                 }
                 mappedPills.push(prefHtml);
               }
            });

            if(!hasValidSamples && !isCompleteSet) {
               mappedPills.push(`<span class="orn-dash__sample-pill" style="border: 1px dashed var(--dash-orange); background: #fffbeb; color: #b45309;">Nog geen samples toegewezen</span>`);
            }
            pills = mappedPills.join('');
          } else {
             if(!isCompleteSet) {
                 pills = `<span class="orn-dash__sample-pill" style="border: 1px dashed var(--dash-orange); background: #fffbeb; color: #b45309;">Nog geen samples toegewezen</span>`;
             }
          }

          let setEditBtnHtml = '';
          let changedBadgeHtml = '';
          {
            let editBtnText = hasValidSamples ? "Selectie bewerken" : "Samples selecteren";
            setEditBtnHtml = `<button type="button" class="orn-btn-outline order-edit-btn" data-id="${order.id}" data-set-index="${index}" style="margin-top:8px; width:100%;" ${setPartHandled ? 'disabled' : ''}>${editBtnText}</button>`;

            let ek = order.id + '-' + index;
            if (orderSampleEditLog[ek]) {
              const orig = orderSampleEditLog[ek].orig;
              const nieuw = orderSampleEditLog[ek].nieuw;
              changedBadgeHtml = `
                <div style="margin-top:6px; position:relative; display:inline-block;">
                  <span class="orn-changed-badge" onclick="var t=this.nextElementSibling;t.classList.toggle('is-open')">✎ Gewijzigd</span>
                  <div class="orn-changed-tooltip">
                    <div class="orn-changed-tooltip__row"><span>Was:</span> ${orig}</div>
                    <div class="orn-changed-tooltip__row orn-changed-tooltip__row--new"><span>Nu:</span> ${nieuw}</div>
                  </div>
                </div>`;
            }
          }

          let setTitleDisplay = order.sets.length > 1 ? `${set.title} (Set ${index + 1})` : set.title;
          const setOptionLabel = getOrderSetOptionLabel(set);

          const setBlockStyle = setPartHandled ? `background: var(--dash-bg); opacity: 0.68;` : '';
          setsHtml += `
            <div class="orn-dash__order-set" style="${setBlockStyle}">
              <div class="orn-dash__set-title">${setTitleDisplay}: <span style="color:var(--dash-orange); font-weight:700;">${setOptionLabel}</span></div>
              ${premiumOrderNoteHtml}
              <div class="orn-dash__order-samples" style="flex-direction:column; gap:8px;">
                <div style="display:flex; flex-wrap:wrap; gap:6px;">${pills}</div>
                ${setEditBtnHtml}${changedBadgeHtml}
              </div>
            </div>`;
        });
      }

      if (!wholeOrderHandled) {
        orderServiceTypes.forEach(type => {
          if (orderCounts[type] !== undefined) orderCounts[type]++;
        });
      }
      if (isMixedOrderCard && !gratisPartHandled) {
        addOrderServiceType('gratis-sample');
        orderCounts['gratis-sample']++;
      }

      let noteHtml = order.note ? `<div class="orn-dash__order-note"><strong>Notitie:</strong> ${order.note}</div>` : '';

      const statusTextAttr = wholeOrderHandled ? 'afgeschreven' : 'pending';
      const mixedGratisSamplesHtml = isMixedOrderCard ? renderMixedGratisSamplesSection(order) : '';
      if (isMixedOrderCard) addOrderServiceType('gratis-sample');
      const servicesForCard = orderServiceTypes.length > 0 ? orderServiceTypes.join(' ') : serviceTypeAttr;

      const setContentsSearch = (order.sets || []).flatMap(set => [
        set.title || '',
        set.option || '',
        getOrderSetOptionLabel(set),
        getOrderSetPremiumCount(set) > 0 ? 'premium' : '',
        ...(set.samples || []),
        ...getDisplayItemsForOrderSet(set).map(item => item.name || '')
      ]).join(' ');
      const gratisContentsSearch = getGratisSamplesArray(order).flatMap(sample => [
        sample.product || '',
        sample.sample || ''
      ]).join(' ');
      const searchData = [
        order.name || '',
        order.customer || '',
        String(order.customer_order_count || ''),
        formatRfmGroupName(order.customer_rfm_group),
        order.note || '',
        setContentsSearch,
        gratisContentsSearch
      ].join(' ').toLowerCase().replace(/"/g, '&quot;');

      html += `
        <div class="orn-dash__order-card ${cardClass}" data-order-id="${order.id}" data-search="${searchData}" data-status="${statusTextAttr}" data-service="${servicesForCard}">
          <div class="orn-dash__order-header">
            <div>
              <div class="orn-dash__order-number">${order.name}</div>
              <div class="orn-dash__order-customer">${formatCustomerLine(order)}</div>
              ${multiOpenOrdersNoticeHtml}
            </div>
            <div style="display:flex; gap:6px; align-items:center;">
              <span class="orn-dash__order-status ${statusClass}">${statusText}</span>
            </div>
          </div>
          ${noteHtml}
          ${setsHtml}

          <div id="wrapper-actions-${order.id}">
            <div class="orn-dash__order-actions" style="margin-top:8px; margin-bottom:8px;">
              ${setPartHandled ?
                `<button class="orn-btn-solid order-action-btn" data-action="prompt-bijschrijven" data-id="${order.id}">${isMixedOrderCard ? '+ Set bijschrijven (Herstel)' : '+ Bijschrijven (Herstel)'}</button>`
                :
                `<button class="orn-btn-solid order-action-btn" data-action="prompt-afschrijven" data-id="${order.id}">${isMixedOrderCard ? '- Set afschrijven' : '- Afschrijven'}</button>`
              }
            </div>
          </div>

          <div class="orn-dash__confirm-box" id="confirm-${order.id}" hidden style="margin-bottom:${isMixedOrderCard ? '14px' : '0'};">
             <p class="orn-dash__confirm-text" id="confirm-text-${order.id}"></p>
             <div class="orn-dash__confirm-actions">
               <button class="orn-btn-outline cancel-action-btn" data-id="${order.id}">Annuleren</button>
               <button class="orn-btn-solid confirm-action-btn" data-id="${order.id}" id="confirm-btn-${order.id}">Ja, opslaan</button>
             </div>
          </div>

          ${mixedGratisSamplesHtml}
        </div>
      `;
    });

    ordersList.innerHTML = html;
    applyOrderFilters();

    document.querySelectorAll('.orn-order-filter-btn').forEach(btn => {
      const type = btn.getAttribute('data-filter');
      const countSpan = btn.querySelector('.filter-count');
      if (countSpan && orderCounts[type] !== undefined) {
        countSpan.textContent = orderCounts[type] > 0 ? ` (${orderCounts[type]})` : '';
      }
    });
  }

  if (ordersList) {
    ordersList.addEventListener('click', async function(e) {
      if (e.target.classList.contains('gratis-edit-btn')) {
        const gsEditId = e.target.getAttribute('data-id');
        const sSampleIdx = parseInt(e.target.getAttribute('data-sample-idx') || '0', 10);
        const gsOrder = localOrders.find(o => o.id.toString() === gsEditId);
        if (!gsOrder) return;

        const samples = getGratisSamplesArray(gsOrder);
        const currentSample = samples[sSampleIdx];

        isManualMode = false;
        currentEditOrderId = gsEditId;
        currentEditSetIndex = -1; // Signaal: gratis sample modal
        currentEditGratisSampleIdx = sSampleIdx;
        modalSelectedSamples = [];
        modalSelectedSampleIds = [];

        const currentName = (currentSample?.sample || '').replace(/^Andere sample:\s*/i, '');
        const currentProduct = (currentSample?.sample_id)
          ? allPerfumesList.find(p => p.id.toString() === currentSample.sample_id.toString())
          : allPerfumesList.find(p => p.name === currentName);
        if (currentProduct) {
          modalSelectedSamples = [currentProduct.name];
          modalSelectedSampleIds = [currentProduct.id];
        }

        document.getElementById('modalOrderName').textContent = `${gsOrder.name} — gratis sample aanpassen`;
        const gsNoteEl = document.getElementById('modalOrderNote');
        if (gsNoteEl) gsNoteEl.style.display = 'none';
        modalSearch.value = '';
        resetModalViews();
        renderModalGrid();
        modal.hidden = false;
        return;
      }

      if (e.target.closest('.gs-prompt-action-btn')) {
        const btn = e.target.closest('.gs-prompt-action-btn');
        const orderId = btn.getAttribute('data-id');
        const sampleIdx = parseInt(btn.getAttribute('data-sample-idx'), 10);
        const action = btn.getAttribute('data-action');

        const actionsWrapper = document.getElementById(`gs-wrapper-actions-${orderId}-${sampleIdx}`);
        const confirmBox = document.getElementById(`gs-confirm-${orderId}-${sampleIdx}`);
        const confirmText = document.getElementById(`gs-confirm-text-${orderId}-${sampleIdx}`);
        const confirmBtn = document.getElementById(`gs-confirm-btn-${orderId}-${sampleIdx}`);

        if (actionsWrapper) actionsWrapper.hidden = true;
        if (confirmBox) confirmBox.hidden = false;

        if (action === 'afschrijven') {
          confirmText.textContent = 'Deze gratis sample van de voorraad afschrijven en direct opslaan?';
          confirmBtn.setAttribute('data-action', 'afschrijven');
        } else if (action === 'geen') {
          confirmText.textContent = 'Bevestigen dat voor deze gratis sample geen afschrijving nodig is?';
          confirmBtn.setAttribute('data-action', 'geen');
        } else if (action === 'herstel') {
          confirmText.textContent = 'Deze gratis sample weer bijschrijven en direct opslaan?';
          confirmBtn.setAttribute('data-action', 'herstel');
        } else {
          confirmText.textContent = 'Markering “geen afschrijving nodig” ongedaan maken?';
          confirmBtn.setAttribute('data-action', 'reset-geen');
        }
        return;
      }

      if (e.target.closest('.gs-cancel-action-btn')) {
        const btn = e.target.closest('.gs-cancel-action-btn');
        const orderId = btn.getAttribute('data-id');
        const sampleIdx = parseInt(btn.getAttribute('data-sample-idx'), 10);

        const actionsWrapper = document.getElementById(`gs-wrapper-actions-${orderId}-${sampleIdx}`);
        const confirmBox = document.getElementById(`gs-confirm-${orderId}-${sampleIdx}`);
        if (confirmBox) confirmBox.hidden = true;
        if (actionsWrapper) actionsWrapper.hidden = false;
        return;
      }

      if (e.target.closest('.gs-confirm-action-btn')) {
        const btn = e.target.closest('.gs-confirm-action-btn');
        const orderId = btn.getAttribute('data-id');
        const sampleIdx = parseInt(btn.getAttribute('data-sample-idx'), 10);
        const action = btn.getAttribute('data-action');

        btn.disabled = true;
        try {
          await handleGratisSampleAction(orderId, sampleIdx, action);
        } finally {
          if (document.body.contains(btn)) btn.disabled = false;
        }
        return;
      }

      if (e.target.classList.contains('order-edit-btn')) {
        openModal(e.target.getAttribute('data-id'), e.target.getAttribute('data-set-index'));
        return;
      }

      if (e.target.classList.contains('order-action-btn')) {
        const orderId = e.target.getAttribute('data-id');
        const action = e.target.getAttribute('data-action');

        document.getElementById(`wrapper-actions-${orderId}`).hidden = true;
        document.getElementById(`confirm-${orderId}`).hidden = false;

        const confirmText = document.getElementById(`confirm-text-${orderId}`);
        const confirmBtn = document.getElementById(`confirm-btn-${orderId}`);

        const currentOrder = localOrders.find(o => o.id.toString() === orderId);
        const mixedAction = currentOrder && isMixedSampleOrder(currentOrder);

        if (action === 'prompt-afschrijven') {
          confirmText.textContent = mixedAction
            ? 'De samples uit deze set afschrijven? De gratis sample(s) verwerk je afzonderlijk.'
            : 'Voorraad aanpassen en direct opslaan in Shopify?';
          confirmBtn.setAttribute('data-action', 'afschrijven');
        } else {
          confirmText.textContent = mixedAction
            ? 'Alleen de samples uit deze set weer bijschrijven?'
            : 'Voorraad weer herstellen en opslaan?';
          confirmBtn.setAttribute('data-action', 'bijschrijven');
        }
      }

      if (e.target.classList.contains('cancel-action-btn')) {
        const orderId = e.target.getAttribute('data-id');
        document.getElementById(`confirm-${orderId}`).hidden = true;
        document.getElementById(`wrapper-actions-${orderId}`).hidden = false;
      }

      if (e.target.classList.contains('confirm-action-btn')) {
        const btn = e.target;
        const orderId = btn.getAttribute('data-id');
        const action = btn.getAttribute('data-action');

        const orderIndex = localOrders.findIndex(o => o.id.toString() === orderId);
        if (orderIndex === -1) return;

        const orderToProcess = localOrders[orderIndex];
        const productIdsToProcess = [];

        (orderToProcess.sets || []).forEach(set => {
          (set.sample_ids || []).forEach(productId => {
            const cleanId = normalizeProductIdForCompare(productId);
            if (cleanId) productIdsToProcess.push(cleanId);
          });
        });

        if (productIdsToProcess.length === 0) {
          alert("Afschrijven is gestopt: deze bestelling heeft geen gekoppelde product-ID's. Open eerst 'Selectie bewerken', controleer de gekozen geuren en sla de selectie opnieuw op.");
          document.getElementById(`confirm-${orderId}`).hidden = true;
          document.getElementById(`wrapper-actions-${orderId}`).hidden = false;
          return;
        }

        const affectedRows = productIdsToProcess.map(productId =>
          allRows.find(r => r.getAttribute('data-product-id').toString() === productId)
        );

        if (affectedRows.some(row => !row)) {
          alert("Afschrijven is gestopt: één of meer gekoppelde product-ID's bestaan niet in de samplevoorraad. Er is niets afgeschreven.");
          document.getElementById(`confirm-${orderId}`).hidden = true;
          document.getElementById(`wrapper-actions-${orderId}`).hidden = false;
          return;
        }

        affectedRows.forEach(row => {
          const stockInput = row.querySelector('.stock-input');
          let currentVal = parseInt(stockInput.value, 10) || 0;
          stockInput.value = action === 'afschrijven' ? currentVal - 1 : currentVal + 1;
        });

        document.getElementById(`confirm-${orderId}`).hidden = true;

        if (isMixedSampleOrder(orderToProcess)) {
          orderToProcess.sets_deducted = (action === 'afschrijven');
        } else {
          orderToProcess.is_deducted = (action === 'afschrijven');
        }
        updateStoredOrderCompletion(orderToProcess, orderId);

        calculateReservations();
        affectedRows.forEach(row => updateRowUI(row, true));

        checkUnsavedChanges();
        await saveDashboardData();
      }
    });
  }

  function updateAnalyticsTable() {
    const analyticsRows = document.querySelectorAll('.analytics-row');
    analyticsRows.forEach(aRow => {
      const id = aRow.getAttribute('data-id');
      const avgDay = parseFloat(aRow.getAttribute('data-avg')) || 0;
      const stockCell = aRow.querySelector('.analytics-stock');
      const runwayCell = aRow.querySelector('.analytics-runway');

      const dashRow = allRows.find(r => r.getAttribute('data-product-id') === id);

      if (dashRow) {
        const stock = parseInt(dashRow.querySelector('.stock-input').value, 10) || 0;
        const stopLim = parseInt(dashRow.querySelector('.stop-limiet-input').value, 10) || 0;

        let effectiveStock = stock - stopLim;
        if (effectiveStock < 0) effectiveStock = 0;

        stockCell.textContent = stock;

        let runway = -1;
        if (avgDay > 0) {
          runway = Math.round(effectiveStock / avgDay);
        }

        if (runway >= 0) {
          if (runway <= 7) {
            runwayCell.innerHTML = `<span style="color: #ef4444; font-weight: 700; background: #fef2f2; padding: 4px 8px; border-radius: 4px; font-size: 11px;">Minder dan ${runway} dgn</span>`;
          } else if (runway <= 21) {
            runwayCell.innerHTML = `<span style="color: var(--dash-orange); font-weight: 600;">${runway} dagen</span>`;
          } else {
            runwayCell.innerHTML = `<span style="color: var(--dash-green); font-weight: 500;">${runway} dagen</span>`;
          }
        } else {
          runwayCell.innerHTML = `<span style="color: #9ca3af;">Onbekend</span>`;
        }
      } else {
        stockCell.textContent = "?";
        runwayCell.innerHTML = `<span style="color: #9ca3af;">Onbekend</span>`;
      }
    });
  }

  const analyticsFilterBtns = document.querySelectorAll('.orn-analytics-filter-btn');
  const analyticsTotalHeader = document.getElementById('analyticsTotalHeader');
  const analyticsTbody = document.getElementById('analyticsTableBody');
  const analyticsSearchInput = document.getElementById('analyticsSearch');

  function renderAnalyticsTable() {
     if(!analyticsTbody) return;

     const activeBtn = document.querySelector('.orn-analytics-filter-btn.is-active');
     const days = activeBtn ? activeBtn.getAttribute('data-days') : '90';
     const query = analyticsSearchInput ? analyticsSearchInput.value.toLowerCase().trim() : '';

     if(days === '1') {
        analyticsTotalHeader.textContent = 'Totaal (24u)';
     } else {
        analyticsTotalHeader.textContent = `Totaal (${days}d)`;
     }

     let rows = Array.from(analyticsTbody.querySelectorAll('.analytics-row'));

     rows.forEach(row => {
        const totalCell = row.querySelector('.analytics-total-cell');
        totalCell.textContent = row.getAttribute(`data-t${days}`);
     });

     rows.sort((a, b) => {
        const valA = parseInt(a.getAttribute(`data-t${days}`), 10) || 0;
        const valB = parseInt(b.getAttribute(`data-t${days}`), 10) || 0;
        return valB - valA;
     });

     let visibleIndex = 1;
     rows.forEach(row => {
        const searchText = row.querySelector('td:nth-child(2)').textContent.toLowerCase();

        if (searchText.includes(query)) {
            row.style.display = '';
            analyticsTbody.appendChild(row);
            row.querySelector('td:first-child').textContent = visibleIndex++;
        } else {
            row.style.display = 'none';
            analyticsTbody.appendChild(row);
        }
     });
  }

  analyticsFilterBtns.forEach(btn => {
     btn.addEventListener('click', function() {
        analyticsFilterBtns.forEach(b => b.classList.remove('is-active'));
        this.classList.add('is-active');
        renderAnalyticsTable();
     });
  });

  if (analyticsSearchInput) {
     analyticsSearchInput.addEventListener('input', renderAnalyticsTable);
  }

  /* =========================================================
     SAMPLE SET VERKOPEN ANALYTICS V1.0
     ========================================================= */
  const setAnalyticsFilterBtns = document.querySelectorAll('.orn-set-analytics-filter-btn');
  const setAnalyticsTotalHeader = document.getElementById('setAnalyticsTotalHeader');
  const setAnalyticsTbody = document.getElementById('setAnalyticsTableBody');
  const setAnalyticsSearchInput = document.getElementById('setAnalyticsSearch');
  const setAnalyticsEmptyRow = document.getElementById('setAnalyticsEmptyRow');

  function formatSetAnalyticsAverage(value) {
    const number = Number(value);
    if (!Number.isFinite(number)) return '0.0';

    let output = (Math.round(number * 100) / 100).toFixed(2);
    if (output.endsWith('.00')) return output.slice(0, -1);
    if (output.endsWith('0')) output = output.slice(0, -1);
    return output;
  }

  function renderSetAnalyticsTable() {
    if (!setAnalyticsTbody) return;

    const activeBtn = document.querySelector('.orn-set-analytics-filter-btn.is-active');
    const days = activeBtn ? activeBtn.getAttribute('data-days') : '90';
    const periodDays = Math.max(parseInt(days, 10) || 90, 1);
    const query = setAnalyticsSearchInput
      ? setAnalyticsSearchInput.value.toLowerCase().trim()
      : '';

    if (setAnalyticsTotalHeader) {
      setAnalyticsTotalHeader.textContent = days === '1'
        ? 'Totaal (24u)'
        : `Totaal (${days}d)`;
    }

    const rows = Array.from(setAnalyticsTbody.querySelectorAll('.set-analytics-row'));

    rows.forEach(row => {
      const total = parseInt(row.getAttribute(`data-t${days}`), 10) || 0;
      const totalCell = row.querySelector('.set-analytics-total');
      const monthCell = row.querySelector('.set-analytics-avg-month');
      const weekCell = row.querySelector('.set-analytics-avg-week');
      const dayCell = row.querySelector('.set-analytics-avg-day');

      if (totalCell) totalCell.textContent = total;
      if (monthCell) monthCell.textContent = formatSetAnalyticsAverage((total / periodDays) * 30);
      if (weekCell) weekCell.textContent = formatSetAnalyticsAverage((total / periodDays) * 7);
      if (dayCell) dayCell.textContent = formatSetAnalyticsAverage(total / periodDays);
    });

    rows.sort((a, b) => {
      const totalA = parseInt(a.getAttribute(`data-t${days}`), 10) || 0;
      const totalB = parseInt(b.getAttribute(`data-t${days}`), 10) || 0;
      if (totalA !== totalB) return totalB - totalA;

      const titleA = a.querySelector('td:nth-child(2) strong')?.textContent || '';
      const titleB = b.querySelector('td:nth-child(2) strong')?.textContent || '';
      return titleA.localeCompare(titleB, 'nl', { sensitivity: 'base' });
    });

    let visibleIndex = 1;
    rows.forEach(row => {
      const searchText = row.getAttribute('data-search') || '';
      const isVisible = !query || searchText.includes(query);

      row.style.display = isVisible ? '' : 'none';
      setAnalyticsTbody.appendChild(row);

      const rankCell = row.querySelector('td:first-child');
      if (rankCell && isVisible) rankCell.textContent = visibleIndex++;
    });

    if (setAnalyticsEmptyRow) {
      if (rows.length === 0) {
        setAnalyticsEmptyRow.hidden = false;
      } else {
        setAnalyticsEmptyRow.hidden = visibleIndex > 1;
        if (!setAnalyticsEmptyRow.hidden) {
          const emptyCell = setAnalyticsEmptyRow.querySelector('td');
          if (emptyCell) emptyCell.textContent = 'Geen sets gevonden.';
        }
      }
      setAnalyticsTbody.appendChild(setAnalyticsEmptyRow);
    }
  }

  setAnalyticsFilterBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      setAnalyticsFilterBtns.forEach(otherBtn => otherBtn.classList.remove('is-active'));
      this.classList.add('is-active');
      renderSetAnalyticsTable();
    });
  });

  if (setAnalyticsSearchInput) {
    setAnalyticsSearchInput.addEventListener('input', renderSetAnalyticsTable);
  }

  renderSetAnalyticsTable();

tableBody.addEventListener('click', function(e) {
    if (e.target.classList.contains('stock-btn')) {
      const row = e.target.closest('.orn-dash__row');
      const input = row.querySelector('.stock-input');
      input.value = (parseInt(input.value, 10) || 0) + parseInt(e.target.getAttribute('data-action'), 10);
      updateRowUI(row, true);
      updateBuisjesProjection();
      refreshTellingFromDashboardStock();
      checkUnsavedChanges();
    }
  });

  tableBody.addEventListener('input', function(e) {
    if (e.target.classList.contains('stock-input')) {
      updateRowUI(e.target.closest('.orn-dash__row'), true);
      updateBuisjesProjection();
      refreshTellingFromDashboardStock();
      checkUnsavedChanges();
    } else if (e.target.classList.contains('limit-input')) {
      updateRowUI(e.target.closest('.orn-dash__row'), true);
      checkUnsavedChanges();
    } else if (e.target.type === 'checkbox') {
      updateRowUI(e.target.closest('.orn-dash__row'), false);
      checkUnsavedChanges();
      calculateRecommendedStock();
      if (e.target.classList.contains('premium-toggle')) applyFiltersAndPaginate(1);
    }
  });

  const btnSendRestock = document.getElementById('btnSendRestock');
  if(btnSendRestock) {
    btnSendRestock.addEventListener('click', async function() {
      const originalHtml = this.innerHTML;

      this.innerHTML = '<span class="orn-loader-ring" style="width:14px; height:14px; border-width:2px; margin:0; border-top-color:currentColor; flex-shrink:0;"></span> Bezig...';
      this.disabled = true;

      const mailWebhookUrl = "https://webhooks.mechanic.dev/c023a018-d171-47e4-804b-3cf57b764c00";

      try {
        const res = await fetch(mailWebhookUrl, { method: 'POST' });
        if(res.ok) {
          this.innerHTML = 'Verzonden!';
          this.style.backgroundColor = 'var(--dash-green)';
          this.style.borderColor = 'var(--dash-green)';
          this.style.color = 'white';

          setTimeout(() => {
            this.innerHTML = originalHtml;
            this.disabled = false;
            this.style.backgroundColor = '';
            this.style.borderColor = '';
            this.style.color = '';
          }, 3000);
        } else {
          throw new Error('Fout bij webhook');
        }
      } catch(e) {
        alert("Kon de mail niet aanvragen. Controleer je internetverbinding.");
        this.innerHTML = originalHtml;
        this.disabled = false;
      }
    });
  }

  async function fetchLiveOrders(isAutoLoad = false) {
    const refreshBtn = document.getElementById('btnRefreshOrders');
    const originalText = refreshBtn ? refreshBtn.innerHTML : 'Sync';

    if (refreshBtn && !isAutoLoad) {
      refreshBtn.innerHTML = 'Laden...';
      refreshBtn.disabled = true;
    }

    try {
      const res = await fetch(window.location.pathname + '?_t=' + Date.now());
      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newStore = doc.getElementById('ornataDataStore');
      if (newStore) {
        document.getElementById('ornataDataStore').setAttribute('data-orders', newStore.getAttribute('data-orders'));
        localOrders = getLocalOrdersFromDOM();
        renderOrders();
        calculateReservations();
        checkUnsavedChanges();
      }
    } catch (e) {
      console.error("Kon live orders niet ophalen:", e);
    }

    if (refreshBtn && !isAutoLoad) {
      refreshBtn.innerHTML = originalText;
      refreshBtn.disabled = false;
    }
  }

  const btnRefreshOrders = document.getElementById('btnRefreshOrders');
  if (btnRefreshOrders) {
    btnRefreshOrders.addEventListener('click', () => fetchLiveOrders(false));
  }

const buisjesVoorraadInput = document.getElementById('buisjesVoorraadInput');
if (buisjesVoorraadInput) {
  buisjesVoorraadInput.addEventListener('input', checkUnsavedChanges);
}

document.querySelectorAll('.orn-buisjes-filter-btn').forEach(btn => {
  btn.addEventListener('click', function() {
    document.querySelectorAll('.orn-buisjes-filter-btn').forEach(b => b.classList.remove('is-active'));
    this.classList.add('is-active');
    updateBuisjesAnalytics();
  });
});

  const TELLING_WEBHOOK_URL = "https://webhooks.mechanic.dev/f19b35b2-3797-47bb-9abf-9bc6e4fe3ee9";

  function getCountQueue() {
    const store = document.getElementById('ornataCountStore');
    if (!store) return [];
    const raw = store.getAttribute('data-queue');
    if (!raw || raw === 'null' || raw.trim() === '') return [];
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch(e) { return []; }
  }

  let countQueue = getCountQueue();
  let pendingTellingResults = []; // { product_id, result, actual_qty, frequency_days }

  function getDashboardStockForProduct(productId) {
    const row = allRows.find(r => r.getAttribute('data-product-id') === productId.toString());
    if (!row) return null;
    const input = row.querySelector('.stock-input');
    if (!input) return null;
    const qty = parseInt(input.value, 10);
    return Number.isFinite(qty) ? Math.max(0, qty) : 0;
  }

  function syncCountQueueExpectedQtyFromDashboard() {
    let changed = false;

    countQueue = countQueue.map(item => {
      const liveQty = getDashboardStockForProduct(item.product_id);
      if (liveQty === null) return item;

      const currentQty = parseInt(item.expected_qty, 10) || 0;
      if (currentQty === liveQty) return item;

      changed = true;
      return Object.assign({}, item, {
        expected_qty: liveQty,
        expected_qty_synced_from_dashboard: true
      });
    });

    if (changed) {
      const store = document.getElementById('ornataCountStore');
      if (store) store.setAttribute('data-queue', JSON.stringify(countQueue));
    }
  }

  function refreshTellingFromDashboardStock() {
    syncCountQueueExpectedQtyFromDashboard();
    renderTellingTable();
  }

  function freqLabel(days) {
    if (days <= 3)  return { text: '2× per week',  cls: 'orn-telling__freq-3' };
    if (days <= 7)  return { text: '1× per week',  cls: 'orn-telling__freq-7' };
    if (days <= 14) return { text: '1× per 2 wkn', cls: 'orn-telling__freq-14' };
    return { text: '1× per 4 wkn', cls: 'orn-telling__freq-28' };
  }

  function renderTellingTable() {
    syncCountQueueExpectedQtyFromDashboard();
    const tbody   = document.getElementById('tellingTableBody');
    const leegMsg = document.getElementById('tellingLeegMsg');
    const tableWrap = document.getElementById('tellingTableWrap');
    const badge   = document.getElementById('tellingDiscrepancyBadge');
    if (!tbody) return;

    const discrepancyCount = pendingTellingResults.filter(r => r.result === 'afwijking').length;

    if (countQueue.length === 0 && pendingTellingResults.length === 0) {
      tableWrap.hidden = true;
      leegMsg.hidden = false;
      return;
    }

    tableWrap.hidden = false;
    leegMsg.hidden = true;

    if (discrepancyCount > 0) {
      badge.textContent = `⚠ ${discrepancyCount} afwijking${discrepancyCount > 1 ? 'en' : ''} — nog niet opgeslagen`;
      badge.hidden = false;
    } else {
      badge.hidden = true;
    }

    const processedIds = pendingTellingResults.map(r => r.product_id.toString());

    let html = '';
    let rowIndex = 1;

    countQueue.slice().sort((a, b) => {
      const brandOrder = String(a.vendor || '').localeCompare(String(b.vendor || ''), 'nl', { sensitivity: 'base', numeric: true });
      return brandOrder || String(a.name || '').localeCompare(String(b.name || ''), 'nl', { sensitivity: 'base', numeric: true });
    }).forEach(item => {
      const pid = item.product_id.toString();
      if (processedIds.includes(pid)) return;
      const freq = freqLabel(item.frequency_days);
      html += buildTellingRow(item, pid, freq, rowIndex++, false);
    });

    pendingTellingResults.forEach(pending => {
      const item = countQueue.find(i => i.product_id.toString() === pending.product_id.toString());
      if (!item) return;
      const freq = freqLabel(item.frequency_days);
      const displayQty = pending.result === 'afwijking' ? pending.actual_qty : item.expected_qty;
      const resultLabel = pending.result === 'afwijking'
        ? `<span style="color:var(--dash-orange); font-size:11px; font-weight:700;">✎ Gecorrigeerd naar ${pending.actual_qty}</span>`
        : `<span style="color:var(--dash-green); font-size:11px; font-weight:700;">✓ Akkoord</span>`;
      html += `
        <tr id="telling-row-${item.product_id}" class="orn-telling__row orn-telling__row-done">
          <td style="text-align:center; color:#9ca3af; font-weight:700;">${rowIndex++}</td>
          <td><strong style="color:#9ca3af;">${item.name}</strong><br><span class="orn-dash__vendor">${item.vendor}</span></td>
          <td style="text-align:center;">${resultLabel}</td>
          <td style="text-align:center;"><span class="orn-telling__freq-badge ${freq.cls}">${freq.text}</span></td>
          <td style="text-align:center; color:#9ca3af;">${item.sales_30d}</td>
          <td style="text-align:center; color:#9ca3af; font-size:12px;">Wordt opgeslagen...</td>
        </tr>
      `;
    });

    tbody.innerHTML = html;
  }

  function buildTellingRow(item, pid, freq, index, isProcessed) {
    return `
      <tr id="telling-row-${pid}" class="orn-telling__row">
        <td style="text-align:center; color:#6b7280; font-weight:700;">${index}</td>
        <td><strong>${item.name}</strong><br><span class="orn-dash__vendor">${item.vendor}</span></td>
        <td style="text-align:center;">
          <div id="telling-stock-display-${pid}" class="orn-telling__stock-display">${item.expected_qty}</div>
          <div id="telling-stock-edit-${pid}" class="orn-telling__stock-edit" hidden>
            <input type="number" class="orn-telling__stock-input" id="telling-input-${pid}" value="${item.expected_qty}" min="0">
          </div>
        </td>
        <td style="text-align:center;"><span class="orn-telling__freq-badge ${freq.cls}">${freq.text}</span></td>
        <td style="text-align:center; font-weight:600; color:#4b5563;">${item.sales_30d}</td>
        <td style="text-align:center;">
          <div id="telling-actions-${pid}" style="display:flex; align-items:center; justify-content:center; gap:8px;">
            <button type="button" class="orn-telling__btn-ok telling-ok-btn" data-pid="${pid}" title="Voorraad klopt">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
            </button>
            <button type="button" class="orn-telling__btn-nok telling-nok-btn" data-pid="${pid}" title="Voorraad klopt niet">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </button>
          </div>
          <div id="telling-confirm-${pid}" style="display:none; align-items:center; justify-content:center; gap:6px; flex-wrap:wrap;">
            <button type="button" class="orn-telling__btn-confirm telling-confirm-btn" data-pid="${pid}" data-freq="${item.frequency_days}">Bevestigen</button>
            <button type="button" class="orn-telling__btn-cancel telling-cancel-btn" data-pid="${pid}">Annuleer</button>
          </div>
        </td>
      </tr>
    `;
  }

  function markTellingPending(productId, result, actualQty, freqDays) {
    pendingTellingResults = pendingTellingResults.filter(r => r.product_id.toString() !== productId.toString());

    pendingTellingResults.push({
      product_id: productId,
      result: result,
      actual_qty: actualQty,
      frequency_days: freqDays
    });

    if (result === 'afwijking') {
      const dashRow = allRows.find(r => r.getAttribute('data-product-id') === productId.toString());
      if (dashRow) {
        const stockInput = dashRow.querySelector('.stock-input');
        stockInput.value = actualQty;
        updateRowUI(dashRow, false);
        updateAnalyticsTable();
      }
    }

    renderTellingTable();
    checkUnsavedChanges();
  }

  async function savePendingTellingResults() {
    if (pendingTellingResults.length === 0) return true;

    try {
      const res = await fetch(TELLING_WEBHOOK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ results: pendingTellingResults })
      });
      if (!res.ok) {
        console.error('Telling webhook fout');
        return false;
      }
    } catch(err) {
      console.error('Telling webhook verbindingsfout:', err);
      return false;
    }

    const processedIds = pendingTellingResults.map(r => r.product_id.toString());
    countQueue = countQueue.filter(i => !processedIds.includes(i.product_id.toString()));
    pendingTellingResults = [];

    const store = document.getElementById('ornataCountStore');
    if (store) store.setAttribute('data-queue', JSON.stringify(countQueue));

    renderTellingTable();
    return true;
  }
  document.addEventListener('click', function(e) {

    if (e.target.closest('.telling-ok-btn')) {
      const btn = e.target.closest('.telling-ok-btn');
      const pid = btn.getAttribute('data-pid');
      syncCountQueueExpectedQtyFromDashboard();
      const item = countQueue.find(i => i.product_id.toString() === pid);
      if (!item) return;
      markTellingPending(pid, 'ok', item.expected_qty, item.frequency_days);
    }

    if (e.target.closest('.telling-nok-btn')) {
      const btn = e.target.closest('.telling-nok-btn');
      const pid = btn.getAttribute('data-pid');
      refreshTellingFromDashboardStock();
      document.getElementById(`telling-stock-display-${pid}`).hidden = true;
      document.getElementById(`telling-stock-edit-${pid}`).hidden = false;
      document.getElementById(`telling-actions-${pid}`).style.display = 'none';
      document.getElementById(`telling-confirm-${pid}`).style.display = 'flex';
      const input = document.getElementById(`telling-input-${pid}`);
      if (input) { input.focus(); input.select(); }
    }

    if (e.target.closest('.telling-confirm-btn')) {
      const btn = e.target.closest('.telling-confirm-btn');
      const pid = btn.getAttribute('data-pid');
      const freq = parseInt(btn.getAttribute('data-freq'), 10);
      const input = document.getElementById(`telling-input-${pid}`);
      const actualQty = parseInt(input.value, 10) || 0;
      markTellingPending(pid, 'afwijking', actualQty, freq);
    }

    if (e.target.closest('.telling-cancel-btn')) {
      const btn = e.target.closest('.telling-cancel-btn');
      const pid = btn.getAttribute('data-pid');
      const item = countQueue.find(i => i.product_id.toString() === pid);
      document.getElementById(`telling-stock-display-${pid}`).hidden = false;
      document.getElementById(`telling-stock-edit-${pid}`).hidden = true;
      document.getElementById(`telling-actions-${pid}`).style.display = 'flex';
      document.getElementById(`telling-confirm-${pid}`).style.display = 'none';
      if (item) document.getElementById(`telling-stock-display-${pid}`).textContent = item.expected_qty;
    }

  });

  let correctieSelectedProduct = null;

  const correctieModal          = document.getElementById('ornCorrectieModal');
  const correctieModalClose     = document.getElementById('ornCorrectieModalClose');
  const correctieModalBackdrop  = document.getElementById('ornCorrectieModalBackdrop');
  const correctieAnnuleren      = document.getElementById('correctieAnnuleren');
  const correctieOpslaan        = document.getElementById('correctieOpslaan');
  const correctieTerug          = document.getElementById('correctieTerug');
  const correctieSearch         = document.getElementById('correctieSearch');
  const correctieGrid           = document.getElementById('correctieGrid');
  const correctieStap1          = document.getElementById('correctieStap1');
  const correctieStap2          = document.getElementById('correctieStap2');
  const correctieStapIndicator  = document.getElementById('correctieStapIndicator');
  const correctieHuidigeVoorraad = document.getElementById('correctieHuidigeVoorraad');
  const correctieNieuweVoorraad = document.getElementById('correctieNieuweVoorraad');
  const correctieDiffInfo       = document.getElementById('correctieDiffInfo');
  const correctieProductInfo    = document.getElementById('correctieProductInfo');

  function openCorrectieModal() {
    correctieSelectedProduct = null;
    correctieSearch.value = '';
    correctieNieuweVoorraad.value = '';
    correctieStap1.hidden = false;
    correctieStap2.hidden = true;
    correctieTerug.hidden = true;
    correctieOpslaan.disabled = true;
    correctieStapIndicator.textContent = 'Stap 1 van 2 — Geur selecteren';
    correctieDiffInfo.style.display = 'none';
    renderCorrectieGrid('');
    correctieModal.hidden = false;
    setTimeout(() => correctieSearch.focus(), 100);
  }

  function closeCorrectieModal() {
    correctieModal.hidden = true;
    correctieSelectedProduct = null;
  }

  function renderCorrectieGrid(query) {
    const q = query.toLowerCase().trim();
    let html = '';
    allPerfumesList.forEach(perfume => {
      if (q && !perfume.searchKey.includes(q)) return;
      const imgHtml = perfume.image
        ? `<img src="${perfume.image}" class="orn-modal-tile-img" alt="${perfume.name}">`
        : `<div class="orn-modal-tile-img" style="background:#f3f4f6;"></div>`;
      const premiumLabel = isPerfumePremium(perfume)
        ? `<div class="orn-dash__premium-tile-label">Premium · +€2</div>`
        : '';
      html += `
        <div class="orn-modal-tile correctie-product-tile" data-pid="${perfume.id}" style="cursor:pointer;">
          ${imgHtml}
          <div style="margin-top:auto;">
            <div class="orn-modal-tile-name">${perfume.name}</div>
            <div class="orn-modal-tile-vendor">${perfume.vendor}</div>
            ${premiumLabel}
          </div>
        </div>
      `;
    });
    correctieGrid.innerHTML = html || '<p style="color:#9ca3af; font-size:13px; text-align:center; padding:20px;">Geen geuren gevonden.</p>';
  }

  function selectCorrectieProduct(pid) {
    const perfume = allPerfumesList.find(p => p.id === pid);
    if (!perfume) return;
    correctieSelectedProduct = perfume;

    const dashRow = allRows.find(r => r.getAttribute('data-product-id') === pid);
    const huidigeVoorraad = dashRow ? (parseInt(dashRow.querySelector('.stock-input').value, 10) || 0) : 0;

    const imgHtml = perfume.image
      ? `<img src="${perfume.image}" style="width:48px; height:48px; object-fit:contain; border-radius:4px; flex-shrink:0;">`
      : `<div style="width:48px; height:48px; background:#f3f4f6; border-radius:4px; flex-shrink:0;"></div>`;

    correctieProductInfo.innerHTML = `
      ${imgHtml}
      <div>
        <div class="orn-correctie__product-name">${perfume.name}</div>
        <div class="orn-correctie__product-vendor">${perfume.vendor}</div>
      </div>
    `;

    correctieHuidigeVoorraad.textContent = huidigeVoorraad;
    correctieNieuweVoorraad.value = huidigeVoorraad;
    correctieDiffInfo.style.display = 'none';

    correctieStap1.hidden = true;
    correctieStap2.hidden = false;
    correctieTerug.hidden = false;
    correctieOpslaan.disabled = false;
    correctieStapIndicator.textContent = 'Stap 2 van 2 — Voorraad corrigeren';

    setTimeout(() => {
      correctieNieuweVoorraad.focus();
      correctieNieuweVoorraad.select();
    }, 100);
  }

  function updateCorrectiediff() {
    if (!correctieSelectedProduct) return;
    const huidig = parseInt(correctieHuidigeVoorraad.textContent, 10) || 0;
    const nieuw  = parseInt(correctieNieuweVoorraad.value, 10);
    if (isNaN(nieuw)) { correctieDiffInfo.style.display = 'none'; return; }
    const diff = nieuw - huidig;
    if (diff === 0) {
      correctieDiffInfo.style.display = 'block';
      correctieDiffInfo.style.background = '#f0fdf4';
      correctieDiffInfo.style.color = '#166534';
      correctieDiffInfo.textContent = '✓ Geen verschil — voorraad klopt al.';
    } else {
      const prefix = diff > 0 ? '+' : '';
      correctieDiffInfo.style.display = 'block';
      correctieDiffInfo.style.background = diff < 0 ? '#fef2f2' : '#fff7ed';
      correctieDiffInfo.style.color = diff < 0 ? '#991b1b' : '#92400e';
      correctieDiffInfo.textContent = `Verschil: ${prefix}${diff} stuks (van ${huidig} naar ${nieuw})`;
    }
  }

  async function saveCorrectie() {
    if (!correctieSelectedProduct) return;
    const huidig = parseInt(correctieHuidigeVoorraad.textContent, 10) || 0;
    const nieuw  = parseInt(correctieNieuweVoorraad.value, 10);
    if (isNaN(nieuw) || nieuw < 0) {
      correctieNieuweVoorraad.style.borderColor = 'var(--dash-red)';
      return;
    }

    correctieOpslaan.disabled = true;
    correctieOpslaan.textContent = 'Opslaan...';

    const payload = {
      results: [{
        product_id: correctieSelectedProduct.id,
        result: 'afwijking',
        actual_qty: nieuw,
        frequency_days: 0,
        manual: true,
        name: correctieSelectedProduct.name,
        vendor: correctieSelectedProduct.vendor,
        expected: huidig
      }]
    };

    try {
      const res = await fetch(TELLING_WEBHOOK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (res.ok) {
        const dashRow = allRows.find(r => r.getAttribute('data-product-id') === correctieSelectedProduct.id);
        if (dashRow) {
          const stockInput = dashRow.querySelector('.stock-input');
          stockInput.value = nieuw;
          updateRowUI(dashRow, false);
          updateAnalyticsTable();
          updateBuisjesProjection();
        }
        closeCorrectieModal();

        await saveDashboardData();

        const badge = document.getElementById('tellingDiscrepancyBadge');
        if (badge) {
          badge.textContent = '✓ Correctie opgeslagen';
          badge.hidden = false;
          setTimeout(() => { badge.hidden = true; }, 3000);
        }
      } else {
        alert('Fout bij opslaan van correctie. Probeer opnieuw.');
        correctieOpslaan.disabled = false;
        correctieOpslaan.textContent = 'Opslaan';
      }
    } catch(err) {
      alert('Verbindingsfout bij opslaan van correctie.');
      correctieOpslaan.disabled = false;
      correctieOpslaan.textContent = 'Opslaan';
    }
  }

  const btnHandmatigeCorrectie = document.getElementById('btnHandmatigeCorrectie');
  if (btnHandmatigeCorrectie) btnHandmatigeCorrectie.addEventListener('click', openCorrectieModal);
  if (correctieModalClose)    correctieModalClose.addEventListener('click', closeCorrectieModal);
  if (correctieModalBackdrop) correctieModalBackdrop.addEventListener('click', closeCorrectieModal);
  if (correctieAnnuleren)     correctieAnnuleren.addEventListener('click', closeCorrectieModal);
  if (correctieOpslaan)       correctieOpslaan.addEventListener('click', saveCorrectie);
  if (correctieTerug) {
    correctieTerug.addEventListener('click', () => {
      correctieStap1.hidden = false;
      correctieStap2.hidden = true;
      correctieTerug.hidden = true;
      correctieOpslaan.disabled = true;
      correctieStapIndicator.textContent = 'Stap 1 van 2 — Geur selecteren';
      correctieSelectedProduct = null;
    });
  }
  if (correctieSearch) {
    correctieSearch.addEventListener('input', () => renderCorrectieGrid(correctieSearch.value));
  }
  if (correctieGrid) {
    correctieGrid.addEventListener('click', e => {
      const tile = e.target.closest('.correctie-product-tile');
      if (tile) selectCorrectieProduct(tile.getAttribute('data-pid'));
    });
  }
  if (correctieNieuweVoorraad) {
    correctieNieuweVoorraad.addEventListener('input', () => {
      correctieNieuweVoorraad.style.borderColor = '';
      updateCorrectiediff();
    });
  }

  const logToggle = document.getElementById('logPanelToggle');
  const logBody = document.getElementById('logPanelBody');
  const logChevron = document.getElementById('logPanelChevron');
  if (logToggle && logBody) {
    logToggle.addEventListener('click', function() {
      const isHidden = logBody.hidden;
      logBody.hidden = !isHidden;
      if (logChevron) logChevron.style.transform = isHidden ? 'rotate(180deg)' : '';
    });
  }

  let pendingSetEdits   = {};
  let pendingSetsCreate = [];
  let pendingSetsDelete = [];

  let currentSetsEditId = null;
  let setsModalProducts = [];

  const setsModal         = document.getElementById('ornSetsModal');
  const setsModalClose    = document.getElementById('ornSetsModalClose');
  const setsModalBackdrop = document.getElementById('ornSetsModalBackdrop');
  const setsModalCancel   = document.getElementById('ornSetsModalCancel');
  const setsModalSaveBtn  = document.getElementById('ornSetsModalSave');
  const setsModalTitle    = document.getElementById('setsModalTitle');
  const setsModalSubtitle = document.getElementById('setsModalSubtitle');
  const setModalName      = document.getElementById('setModalName');
  const setModalOrder     = document.getElementById('setModalOrder');
  const setModalActive    = document.getElementById('setModalActive');
  const setModalDesc      = document.getElementById('setModalDescription');
  const setModalSearch    = document.getElementById('setModalSearch');
  const setModalProdList  = document.getElementById('setModalProductList');
  const setModalNoProdMsg = document.getElementById('setModalNoProdMsg');
  const setModalProdGrid  = document.getElementById('setModalProductGrid');
  const setModalProdCount = document.getElementById('setModalProdCount');
  const btnNewSet         = document.getElementById('btnNewSet');
  const setsManageBody    = document.getElementById('setsManageBody');

  function isSetInOpenOrders(setTitle) {
    if (!setTitle) return false;
    const needle = setTitle.toLowerCase().trim();
    return localOrders.some(function(order) {
      if (order.is_deducted || order.no_deduct_needed) return false;
      if (!order.sets) return false;
      return order.sets.some(function(set) {
        if (!set.samples) return false;
        return set.samples.some(function(s) {
          return s.toLowerCase().includes(needle);
        });
      });
    });
  }

  function updateSetDeleteBtnState(row) {
    const btn = row.querySelector('.set-delete-btn');
    if (!btn) return;
    const toggle    = row.querySelector('.set-active-toggle');
    const title     = row.getAttribute('data-set-title') || '';
    const isActive  = toggle ? toggle.checked : false;
    const hasOrders = isSetInOpenOrders(title);
    const disabled  = isActive || hasOrders;

    btn.disabled = disabled;
    if (hasOrders && !isActive) {
      btn.title = 'Er zijn nog openstaande bestellingen met deze set';
    } else if (isActive) {
      btn.title = 'Deactiveer de set eerst';
    } else {
      btn.title = '';
    }
  }

  function openSetsModal(setId) {
    currentSetsEditId = setId || null;
    setsModalProducts = [];

    if (setId) {
      const row = setsManageBody
  ? Array.from(setsManageBody.querySelectorAll('.sets-manage-row')).find(function(r) { return r.getAttribute('data-set-id') === setId; })
  : null;
      if (!row) return;

      setsModalTitle.textContent    = 'Set bewerken';
      setsModalSubtitle.textContent = row.getAttribute('data-set-title') || '';
      setModalName.value            = row.getAttribute('data-set-title') || '';
      setModalOrder.value           = row.getAttribute('data-set-sort') || '0';
      setModalActive.checked        = row.getAttribute('data-set-is-active') !== 'false';
      setModalDesc.value            = row.getAttribute('data-set-description') || '';

      const edit = pendingSetEdits[setId];
      if (edit) {
        if (edit.title       !== undefined) setModalName.value     = edit.title;
        if (edit.sort_order  !== undefined) setModalOrder.value    = edit.sort_order;
        if (edit.is_active   !== undefined) setModalActive.checked = edit.is_active;
        if (edit.description !== undefined) setModalDesc.value     = edit.description;
        if (edit.product_ids) {
          setsModalProducts = edit.product_ids.map(function(pid) {
            const p = allPerfumesList.find(function(x) { return x.id === pid; });
            return p ? { id: p.id, title: p.name, vendor: p.vendor, image: p.image } : null;
          }).filter(Boolean);
        }
      }

      if (!edit || !edit.product_ids) {
        const pids = (row.getAttribute('data-set-pids') || '').split(',').filter(Boolean);
        setsModalProducts = pids.map(function(pid) {
          const p = allPerfumesList.find(function(x) { return x.id === pid; });
          return p ? { id: p.id, title: p.name, vendor: p.vendor, image: p.image } : null;
        }).filter(Boolean);
      }

    } else {
      setsModalTitle.textContent    = 'Nieuwe set aanmaken';
      setsModalSubtitle.textContent = '';
      setModalName.value            = '';
      setModalOrder.value           = '0';
      setModalActive.checked        = true;
      setModalDesc.value            = '';
    }

    setModalName.style.borderColor = '';
    setModalSearch.value = '';
    renderSetsModalProductList();
    renderSetsModalProductGrid('');
    if (setsModal) setsModal.hidden = false;
  }

  function closeSetsModal() {
    if (setsModal) setsModal.hidden = true;
    currentSetsEditId = null;
    setsModalProducts = [];
  }

  function renderSetsModalProductList() {
    if (!setModalProdList) return;
    setModalProdList.innerHTML = '';

    if (setsModalProducts.length === 0) {
      setModalNoProdMsg.style.display = 'inline';
      setModalProdList.appendChild(setModalNoProdMsg);
      if (setModalProdCount) setModalProdCount.textContent = '(0)';
      return;
    }

    setModalNoProdMsg.style.display = 'none';
    const total = setsModalProducts.length;

    setsModalProducts.forEach(function(product, idx) {
      const pill = document.createElement('div');
      pill.className = 'orn-sets-product-pill';
      pill.innerHTML =
        '<button type="button" class="orn-sets-pill-up" data-idx="' + idx + '" ' + (idx === 0 ? 'disabled' : '') + '>↑</button>' +
        '<button type="button" class="orn-sets-pill-down" data-idx="' + idx + '" ' + (idx === total - 1 ? 'disabled' : '') + '>↓</button>' +
        '<span class="orn-sets-pill-name">' + product.title + '</span>' +
        '<button type="button" class="orn-sets-pill-remove" data-idx="' + idx + '" title="Verwijderen">' +
          '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>';
      setModalProdList.appendChild(pill);
    });

    if (setModalProdCount) setModalProdCount.textContent = '(' + total + ')';
  }

  function renderSetsModalProductGrid(query) {
    if (!setModalProdGrid) return;
    const q = (query || '').toLowerCase().trim();
    const selectedIds = setsModalProducts.map(function(p) { return p.id; });
    let html = '';

    allPerfumesList.forEach(function(perfume) {
      if (q && !perfume.searchKey.includes(q)) return;
      const isSel = selectedIds.indexOf(perfume.id) > -1;
      html +=
        '<div class="orn-sets-grid-tile ' + (isSel ? 'is-selected' : '') + '" data-pid="' + perfume.id + '" ' +
          'style="border:2px solid ' + (isSel ? 'var(--dash-dark)' : 'var(--dash-border)') + '; background:' + (isSel ? '#f8fafc' : 'white') + ';">' +
          (isSel ? '<div style="position:absolute;top:5px;right:5px;width:16px;height:16px;background:var(--dash-dark);border-radius:50%;display:flex;align-items:center;justify-content:center;"><svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3.5"><polyline points="20 6 9 17 4 12"/></svg></div>' : '') +
          (perfume.image ? '<img src="' + perfume.image + '" style="width:48px;height:48px;object-fit:contain;display:block;margin:0 auto 4px;">' : '<div style="width:48px;height:48px;background:#f3f4f6;margin:0 auto 4px;border-radius:4px;"></div>') +
          '<div style="font-size:10px;font-weight:600;line-height:1.3;color:var(--dash-dark);">' + perfume.name + '</div>' +
          '<div style="font-size:9px;color:#6b7280;text-transform:uppercase;letter-spacing:0.03em;">' + perfume.vendor + '</div>' +
          (isPerfumePremium(perfume) ? '<div class="orn-dash__premium-tile-label">Premium · +€2</div>' : '') +
        '</div>';
    });

    setModalProdGrid.innerHTML = html;
  }

  function saveSetsModal() {
    const name = setModalName.value.trim();
    if (!name) {
      setModalName.style.borderColor = 'var(--dash-red)';
      setModalName.focus();
      return;
    }
    setModalName.style.borderColor = '';

    const isActive  = setModalActive.checked;
    const sortOrder = parseInt(setModalOrder.value, 10) || 0;
    const desc      = setModalDesc.value.trim();
    const productIds = setsModalProducts.map(function(p) { return p.id; });
    const isCustom  = productIds.length > 5;

    if (currentSetsEditId) {
      pendingSetEdits[currentSetsEditId] = {
        title: name, description: desc, sort_order: sortOrder,
        is_active: isActive, product_ids: productIds, is_custom: isCustom,
        _modal: true
      };

      const row = setsManageBody
  ? Array.from(setsManageBody.querySelectorAll('.sets-manage-row')).find(function(r) { return r.getAttribute('data-set-id') === currentSetsEditId; })
  : null;

      if (row) {
        row.querySelector('strong').textContent = name;
        row.setAttribute('data-set-title',       name);
        row.setAttribute('data-set-description', desc);
        row.setAttribute('data-set-sort',        sortOrder);
        row.setAttribute('data-set-pids',        productIds.join(','));
        row.setAttribute('data-set-is-active',   isActive.toString());
        row.setAttribute('data-set-is-custom',   isCustom.toString());

        const vendorEl = row.querySelector('.orn-dash__vendor');
        if (vendorEl) vendorEl.textContent = desc ? desc.substring(0, 60) + (desc.length > 60 ? '…' : '') : '';

        row.querySelector('.set-active-toggle').checked = isActive;
        row.querySelector('.set-order-input').value     = sortOrder;

        const countCell = row.cells[3];
        if (countCell) countCell.textContent = productIds.length;

        const badge = row.querySelector('.orn-telling__freq-badge');
        if (badge) {
          badge.textContent = isCustom ? 'Custom' : 'Vast';
          badge.className   = 'orn-telling__freq-badge ' + (isCustom ? 'orn-telling__freq-7' : 'orn-telling__freq-28');
        }

        row.classList.toggle('sets-row--inactive', !isActive);
        updateSetDeleteBtnState(row);
      }

    } else {
      const tempId = 'new-' + Date.now();
      pendingSetsCreate.push({ tempId: tempId, title: name, description: desc,
        sort_order: sortOrder, is_active: isActive, product_ids: productIds, is_custom: isCustom });

      const newRow = document.createElement('tr');
      newRow.className = 'sets-manage-row' + (isActive ? '' : ' sets-row--inactive');
      newRow.setAttribute('data-set-id',         tempId);
      newRow.setAttribute('data-set-title',       name);
      newRow.setAttribute('data-set-description', desc);
      newRow.setAttribute('data-set-sort',        sortOrder);
      newRow.setAttribute('data-set-is-custom',   isCustom.toString());
      newRow.setAttribute('data-set-pids',        productIds.join(','));
      newRow.setAttribute('data-set-is-active',   isActive.toString());
      newRow.innerHTML =
        '<td style="text-align:center;vertical-align:middle;">' +
          '<label class="orn-dash__toggle"><input type="checkbox" class="set-active-toggle" data-original="new" ' + (isActive ? 'checked' : '') + '><span class="orn-dash__slider"></span></label>' +
        '</td>' +
        '<td style="vertical-align:middle;"><strong>' + name + '</strong>' + (desc ? '<br><span class="orn-dash__vendor">' + desc.substring(0,60) + '</span>' : '') + '</td>' +
        '<td style="text-align:center;vertical-align:middle;"><span class="orn-telling__freq-badge ' + (isCustom ? 'orn-telling__freq-7' : 'orn-telling__freq-28') + '">' + (isCustom ? 'Custom' : 'Vast') + '</span></td>' +
        '<td style="text-align:center;vertical-align:middle;font-weight:700;">' + productIds.length + '</td>' +
        '<td style="text-align:center;vertical-align:middle;"><input type="number" class="limit-input set-order-input" value="' + sortOrder + '" data-original="new"></td>' +
        '<td style="vertical-align:middle;">' +
          '<div class="sets-row-actions" style="display:flex;gap:6px;">' +
            '<button type="button" class="orn-btn-outline set-edit-btn" style="flex:1;padding:5px 8px;font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:0.05em;">Bewerken</button>' +
            '<button type="button" class="set-delete-btn orn-btn-outline" style="flex:1;padding:5px 8px;font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:0.05em;" disabled>Verwijderen</button>' +
          '</div>' +
          '<div class="sets-delete-confirm" style="display:none;margin-top:8px;background:#fef2f2;border:1px solid #fecaca;border-radius:4px;padding:10px;">' +
            '<p style="font-size:12px;font-weight:600;color:#991b1b;margin:0 0 8px;">Definitief verwijderen?</p>' +
            '<div style="display:flex;gap:6px;">' +
              '<button type="button" class="orn-btn-outline sets-cancel-delete" style="flex:1;font-size:11px;padding:4px 8px;">Nee</button>' +
              '<button type="button" class="orn-btn-solid sets-confirm-delete" style="flex:1;font-size:11px;padding:4px 8px;background:var(--dash-red);border-color:var(--dash-red);">Ja</button>' +
            '</div>' +
          '</div>' +
        '</td>';

      if (setsManageBody) setsManageBody.appendChild(newRow);
      updateSetDeleteBtnState(newRow);
    }

    checkUnsavedChanges();
    closeSetsModal();
  }

  if (setsModalClose)    setsModalClose.addEventListener('click', closeSetsModal);
  if (setsModalBackdrop) setsModalBackdrop.addEventListener('click', closeSetsModal);
  if (setsModalCancel)   setsModalCancel.addEventListener('click', closeSetsModal);
  if (setsModalSaveBtn)  setsModalSaveBtn.addEventListener('click', saveSetsModal);
  if (btnNewSet)         btnNewSet.addEventListener('click', function() { openSetsModal(null); });

  if (setModalSearch) {
    setModalSearch.addEventListener('input', function() {
      renderSetsModalProductGrid(setModalSearch.value);
    });
  }
  if (setModalName) {
    setModalName.addEventListener('input', function() { setModalName.style.borderColor = ''; });
  }

  if (setModalProdGrid) {
    setModalProdGrid.addEventListener('click', function(e) {
      const tile = e.target.closest('.orn-sets-grid-tile');
      if (!tile) return;
      const pid = tile.getAttribute('data-pid');
      const idx = setsModalProducts.findIndex(function(p) { return p.id === pid; });
      if (idx > -1) {
        setsModalProducts.splice(idx, 1);
      } else {
        const pf = allPerfumesList.find(function(p) { return p.id === pid; });
        if (pf) setsModalProducts.push({ id: pf.id, title: pf.name, vendor: pf.vendor, image: pf.image });
      }
      renderSetsModalProductList();
      renderSetsModalProductGrid(setModalSearch ? setModalSearch.value : '');
    });
  }

  if (setModalProdList) {
    setModalProdList.addEventListener('click', function(e) {
      const up     = e.target.closest('.orn-sets-pill-up');
      const down   = e.target.closest('.orn-sets-pill-down');
      const remove = e.target.closest('.orn-sets-pill-remove');
      let idx;

      if (up) {
        idx = parseInt(up.getAttribute('data-idx'), 10);
        if (idx > 0) {
          const tmp = setsModalProducts[idx - 1];
          setsModalProducts[idx - 1] = setsModalProducts[idx];
          setsModalProducts[idx] = tmp;
          renderSetsModalProductList();
          renderSetsModalProductGrid(setModalSearch ? setModalSearch.value : '');
        }
      } else if (down) {
        idx = parseInt(down.getAttribute('data-idx'), 10);
        if (idx < setsModalProducts.length - 1) {
          const tmp = setsModalProducts[idx + 1];
          setsModalProducts[idx + 1] = setsModalProducts[idx];
          setsModalProducts[idx] = tmp;
          renderSetsModalProductList();
          renderSetsModalProductGrid(setModalSearch ? setModalSearch.value : '');
        }
      } else if (remove) {
        idx = parseInt(remove.getAttribute('data-idx'), 10);
        setsModalProducts.splice(idx, 1);
        renderSetsModalProductList();
        renderSetsModalProductGrid(setModalSearch ? setModalSearch.value : '');
      }
    });
  }

  if (setsManageBody) {
    setsManageBody.addEventListener('click', function(e) {
      const row = e.target.closest('.sets-manage-row');
      if (!row) return;
      const setId = row.getAttribute('data-set-id');

      if (e.target.closest('.set-edit-btn')) {
        openSetsModal(setId);
        return;
      }
      if (e.target.closest('.set-delete-btn') && !e.target.closest('.set-delete-btn').disabled) {
        row.querySelector('.sets-row-actions').style.display = 'none';
        row.querySelector('.sets-delete-confirm').style.display = 'block';
        return;
      }
      if (e.target.closest('.sets-cancel-delete')) {
        row.querySelector('.sets-row-actions').style.display = 'flex';
        row.querySelector('.sets-delete-confirm').style.display = 'none';
        return;
      }
      if (e.target.closest('.sets-confirm-delete')) {
        if (!setId.startsWith('new-')) {
          pendingSetsDelete.push(setId);
        } else {
          pendingSetsCreate = pendingSetsCreate.filter(function(s) { return s.tempId !== setId; });
        }
        delete pendingSetEdits[setId];
        row.remove();
        checkUnsavedChanges();
      }
    });

    setsManageBody.addEventListener('change', function(e) {
      if (!e.target.classList.contains('set-active-toggle')) return;
      const row    = e.target.closest('.sets-manage-row');
      if (!row) return;
      const setId  = row.getAttribute('data-set-id');
      if (setId.startsWith('new-')) return;
      const active = e.target.checked;

      row.classList.toggle('sets-row--inactive', !active);
      row.setAttribute('data-set-is-active', active.toString());

      const originalActive = e.target.getAttribute('data-original') === 'true';
      const orderInput = row.querySelector('.set-order-input');
      const originalSort = parseInt(orderInput.getAttribute('data-original'), 10) || 0;
      const currentSort  = parseInt(orderInput.value, 10) || 0;

      if (active === originalActive && currentSort === originalSort && pendingSetEdits[setId] && !pendingSetEdits[setId]._modal) {
        delete pendingSetEdits[setId];
      } else if (active !== originalActive) {
        if (!pendingSetEdits[setId]) {
          pendingSetEdits[setId] = {
            title:       row.getAttribute('data-set-title'),
            description: row.getAttribute('data-set-description'),
            sort_order:  currentSort,
            product_ids: (row.getAttribute('data-set-pids') || '').split(',').filter(Boolean),
            is_custom:   row.getAttribute('data-set-is-custom') === 'true'
          };
        }
        pendingSetEdits[setId].is_active = active;
      }

      updateSetDeleteBtnState(row);
      checkUnsavedChanges();
    });

    setsManageBody.addEventListener('input', function(e) {
      if (!e.target.classList.contains('set-order-input')) return;
      const row   = e.target.closest('.sets-manage-row');
      if (!row) return;
      const setId = row.getAttribute('data-set-id');
        if (setId.startsWith('new-')) return;
      const order = parseInt(e.target.value, 10) || 0;

      const originalSort   = parseInt(e.target.getAttribute('data-original'), 10) || 0;
      const toggle         = row.querySelector('.set-active-toggle');
      const originalActive = toggle ? toggle.getAttribute('data-original') === 'true' : true;
      const currentActive  = toggle ? toggle.checked : true;

      if (order === originalSort && currentActive === originalActive && pendingSetEdits[setId] && !pendingSetEdits[setId]._modal) {
        delete pendingSetEdits[setId];
      } else if (order !== originalSort) {
        if (!pendingSetEdits[setId]) {
          pendingSetEdits[setId] = {
            title:       row.getAttribute('data-set-title'),
            description: row.getAttribute('data-set-description'),
            is_active:   currentActive,
            product_ids: (row.getAttribute('data-set-pids') || '').split(',').filter(Boolean),
            is_custom:   row.getAttribute('data-set-is-custom') === 'true'
          };
        }
        pendingSetEdits[setId].sort_order = order;
      }
      checkUnsavedChanges();
    });
  }

  document.querySelectorAll('.sets-manage-row').forEach(function(row) {
    updateSetDeleteBtnState(row);
  });

  calculateReservations();
  applyFiltersAndPaginate(1);
  renderOrders();
  checkUnsavedChanges();
  updateAnalyticsTable();
  calculateRecommendedStock();
  updateBuisjesAnalytics();
  renderTellingTable();

  fetchLiveOrders(true);

  setInterval(() => {
    fetchLiveOrders(true);
  }, 60000);

  function updateReviewRowVisual(row, isActive, forcedStatus = null) {
    if (!row) return;

    const status = forcedStatus || (isActive ? 'active' : 'inactive');

    row.setAttribute('data-review-active', isActive ? 'true' : 'false');
    row.setAttribute('data-review-status', status);
    row.classList.toggle('review-row--inactive', status === 'inactive');
    row.classList.toggle('review-row--pending', status === 'pending');

    const rejectBtn = row.querySelector('.review-reject-btn');
    if (rejectBtn) rejectBtn.style.display = status === 'pending' ? '' : 'none';

    const badge = row.querySelector('.review-status-badge');
    if (badge) {
      if (status === 'active') {
        badge.textContent = 'Actief';
        badge.style.background = '#ecfdf5';
        badge.style.color = '#047857';
      } else if (status === 'pending') {
        badge.textContent = 'Te beoordelen';
        badge.style.background = '#fff7ed';
        badge.style.color = '#c2410c';
      } else {
        badge.textContent = 'Inactief';
        badge.style.background = '#f3f4f6';
        badge.style.color = '#6b7280';
      }
    }

    updateReviewPendingCount();
  }

  function updateReviewPendingCount() {
    const countEl = document.getElementById('reviewPendingCount');
    if (!countEl) return;

    const count = document.querySelectorAll('.review-row[data-review-status="pending"]').length;
    countEl.textContent = count > 0 ? ` (${count})` : '';
  }

  async function saveReviewActiveState(toggle) {
    const row = toggle.closest('.review-row');
    const reviewId = toggle.getAttribute('data-review-id');
    const isActive = toggle.checked;

    if (!reviewId) {
      alert('Review-ID ontbreekt. Kan status niet opslaan.');
      toggle.checked = !isActive;
      return;
    }

    toggle.disabled = true;

    const webhookUrl = "https://webhooks.mechanic.dev/04ce111b-d163-40d1-b6c1-40a2bfefac4c";
    const payload = {
      operation_id: createDashboardOperationId(),
      review_updates: [
        {
          id: reviewId,
          actief_value: isActive ? 'true' : 'false',
          actief: isActive
        }
      ]
    };

    try {
      const res = await fetch(webhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!res.ok) throw new Error('Mechanic webhook gaf geen OK terug.');

      updateReviewRowVisual(row, isActive);
      toggle.setAttribute('data-original', isActive ? 'true' : 'false');

      const badge = row.querySelector('.review-status-badge');
      if (badge) {
        badge.textContent = 'Opgeslagen';
        setTimeout(() => {
          badge.textContent = isActive ? 'Actief' : 'Inactief';
        }, 1000);
      }
    } catch (err) {
      toggle.checked = !isActive;
      updateReviewRowVisual(row, !isActive);
      alert('Kon reviewstatus niet opslaan: ' + err.message);
    } finally {
      toggle.disabled = false;
    }
  }

  function getReviewEditRow(row) {
    const reviewId = row?.getAttribute('data-review-id');
    if (!reviewId) return null;
    return document.querySelector(`.review-edit-row[data-review-edit-for="${CSS.escape(reviewId)}"]`);
  }

  function closeReviewEditRow(row) {
    const editRow = getReviewEditRow(row);
    if (editRow) editRow.hidden = true;
  }

  function openReviewEditRow(row) {
    const editRow = getReviewEditRow(row);
    if (!editRow) return;

    const authorInput = editRow.querySelector('.review-edit-author');
    const bodyInput = editRow.querySelector('.review-edit-body');

    if (authorInput) authorInput.value = row.getAttribute('data-review-author') || '';
    if (bodyInput) bodyInput.value = row.getAttribute('data-review-body') || '';

    editRow.hidden = false;
  }

  async function saveReviewTextEdit(row) {
    const editRow = getReviewEditRow(row);
    if (!editRow) return;

    const reviewId = row.getAttribute('data-review-id');
    const authorInput = editRow.querySelector('.review-edit-author');
    const bodyInput = editRow.querySelector('.review-edit-body');
    const saveBtn = editRow.querySelector('.review-edit-save');

    const author = (authorInput?.value || '').trim();
    const body = (bodyInput?.value || '').trim();

    if (!author) {
      alert('Naam/auteur mag niet leeg zijn.');
      return;
    }

    if (!body) {
      alert('Reviewtekst mag niet leeg zijn.');
      return;
    }

    saveBtn.disabled = true;
    const oldText = saveBtn.textContent;
    saveBtn.textContent = 'Opslaan...';

    const webhookUrl = "https://webhooks.mechanic.dev/04ce111b-d163-40d1-b6c1-40a2bfefac4c";
    const payload = {
      operation_id: createDashboardOperationId(),
      review_updates: [
        {
          id: reviewId,
          author: author,
          body: body
        }
      ]
    };

    try {
      const res = await fetch(webhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!res.ok) throw new Error('Mechanic webhook gaf geen OK terug.');

      row.setAttribute('data-review-author', author);
      row.setAttribute('data-review-body', body);
      row.setAttribute('data-search', [
        row.querySelector('td:nth-child(2) strong')?.textContent || '',
        row.querySelector('td:nth-child(4) strong')?.textContent || '',
        body,
        author
      ].join(' ').toLowerCase());

      const authorDisplay = row.querySelector('.review-author-display');
      const bodyDisplay = row.querySelector('.review-body-display');
      if (authorDisplay) authorDisplay.textContent = author;
      if (bodyDisplay) bodyDisplay.textContent = body;

      closeReviewEditRow(row);
    } catch (err) {
      alert('Kon review niet opslaan: ' + err.message);
    } finally {
      saveBtn.disabled = false;
      saveBtn.textContent = oldText;
    }
  }

  function getReviewDeleteConfirmRow(row) {
    const reviewId = row?.getAttribute('data-review-id');
    if (!reviewId) return null;
    return document.querySelector(`.review-delete-confirm-row[data-review-delete-for="${CSS.escape(reviewId)}"]`);
  }

  function openReviewDeleteConfirm(row) {
    if (!row) return;

    closeReviewEditRow(row);

    const confirmRow = getReviewDeleteConfirmRow(row);
    if (!confirmRow) return;

    document.querySelectorAll('.review-delete-confirm-row').forEach(r => {
      if (r !== confirmRow) r.hidden = true;
    });

    confirmRow.hidden = false;
  }

  function closeReviewDeleteConfirm(row) {
    const confirmRow = getReviewDeleteConfirmRow(row);
    if (confirmRow) confirmRow.hidden = true;
  }

  function setReviewStatusFilter(filterValue) {
    document.querySelectorAll('.review-filter-btn').forEach(btn => {
      btn.classList.toggle('is-active', btn.getAttribute('data-review-filter') === filterValue);
    });
  }

  function getActiveReviewStatusFilter() {
    return document.querySelector('.review-filter-btn.is-active')?.getAttribute('data-review-filter') || 'all';
  }

  async function deleteReview(row) {
    if (!row) return;

    const reviewId = row.getAttribute('data-review-id');
    const confirmRow = getReviewDeleteConfirmRow(row);
    const confirmBtn = confirmRow?.querySelector('.review-delete-confirm');

    if (confirmBtn) {
      confirmBtn.disabled = true;
      confirmBtn.textContent = 'Verwijderen...';
    }

    const webhookUrl = "https://webhooks.mechanic.dev/04ce111b-d163-40d1-b6c1-40a2bfefac4c";
    const payload = {
      operation_id: createDashboardOperationId(),
      review_deletes: [reviewId]
    };

    try {
      const res = await fetch(webhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!res.ok) throw new Error('Mechanic webhook gaf geen OK terug.');

      const editRow = getReviewEditRow(row);
      if (editRow) editRow.remove();
      if (confirmRow) confirmRow.remove();
      row.remove();

      updateReviewPendingCount();

      const activeFilter = getActiveReviewStatusFilter();
      const pendingLeft = document.querySelectorAll('.review-row[data-review-status="pending"]').length;

      if (activeFilter === 'pending' && pendingLeft === 0) {
        setReviewStatusFilter('all');
      }

      applyReviewFilters();
    } catch (err) {
      alert('Kon review niet verwijderen: ' + err.message);
      if (confirmBtn) {
        confirmBtn.disabled = false;
        confirmBtn.textContent = 'Ja, verwijderen';
      }
    }
  }

  function applyReviewFilters() {
    const search = (document.getElementById('reviewSearch')?.value || '').toLowerCase().trim();
    const activeFilter = document.querySelector('.review-filter-btn.is-active')?.getAttribute('data-review-filter') || 'all';
    const ratingFilter = document.getElementById('reviewRatingFilter')?.value || 'all';

    document.querySelectorAll('.review-row').forEach(row => {
      const haystack = row.getAttribute('data-search') || '';
      const status = row.getAttribute('data-review-status') || (row.getAttribute('data-review-active') === 'true' ? 'active' : 'inactive');
      const rating = String(parseInt(row.getAttribute('data-review-rating') || '0', 10) || 0);

      let visible = true;
      if (search && !haystack.includes(search)) visible = false;
      if (activeFilter === 'active' && status !== 'active') visible = false;
      if (activeFilter === 'inactive' && status !== 'inactive') visible = false;
      if (activeFilter === 'pending' && status !== 'pending') visible = false;
      if (ratingFilter !== 'all' && rating !== ratingFilter) visible = false;

      row.style.display = visible ? '' : 'none';

      const editRow = getReviewEditRow(row);
      const deleteRow = getReviewDeleteConfirmRow(row);

      if (!visible) {
        if (editRow) editRow.hidden = true;
        if (deleteRow) deleteRow.hidden = true;
      }
    });
  }

  document.addEventListener('click', function(e) {
    const editBtn = e.target.closest('.review-edit-btn');
    if (editBtn) {
      const row = editBtn.closest('.review-row');
      closeReviewDeleteConfirm(row);
      const editRow = getReviewEditRow(row);
      if (editRow) editRow.hidden ? openReviewEditRow(row) : closeReviewEditRow(row);
      return;
    }

    const cancelBtn = e.target.closest('.review-edit-cancel');
    if (cancelBtn) {
      const editRow = cancelBtn.closest('.review-edit-row');
      const reviewId = editRow?.getAttribute('data-review-edit-for');
      const row = document.querySelector(`.review-row[data-review-id="${CSS.escape(reviewId || '')}"]`);
      closeReviewEditRow(row);
      return;
    }

    const saveBtn = e.target.closest('.review-edit-save');
    if (saveBtn) {
      const editRow = saveBtn.closest('.review-edit-row');
      const reviewId = editRow?.getAttribute('data-review-edit-for');
      const row = document.querySelector(`.review-row[data-review-id="${CSS.escape(reviewId || '')}"]`);
      saveReviewTextEdit(row);
      return;
    }

    const rejectBtn = e.target.closest('.review-reject-btn');
    if (rejectBtn) {
      const row = rejectBtn.closest('.review-row');
      const toggle = row?.querySelector('.review-active-toggle');
      if (toggle) {
        toggle.checked = false;
        saveReviewActiveState(toggle);
      }
      return;
    }

    const deleteBtn = e.target.closest('.review-delete-btn');
    if (deleteBtn) {
      const row = deleteBtn.closest('.review-row');
      openReviewDeleteConfirm(row);
      return;
    }

    const deleteCancelBtn = e.target.closest('.review-delete-cancel');
    if (deleteCancelBtn) {
      const confirmRow = deleteCancelBtn.closest('.review-delete-confirm-row');
      const reviewId = confirmRow?.getAttribute('data-review-delete-for');
      const row = document.querySelector(`.review-row[data-review-id="${CSS.escape(reviewId || '')}"]`);
      closeReviewDeleteConfirm(row);
      return;
    }

    const deleteConfirmBtn = e.target.closest('.review-delete-confirm');
    if (deleteConfirmBtn) {
      const confirmRow = deleteConfirmBtn.closest('.review-delete-confirm-row');
      const reviewId = confirmRow?.getAttribute('data-review-delete-for');
      const row = document.querySelector(`.review-row[data-review-id="${CSS.escape(reviewId || '')}"]`);
      deleteReview(row);
    }
  });

  document.addEventListener('change', function(e) {
    if (e.target.classList.contains('review-active-toggle')) {
      saveReviewActiveState(e.target);
    }
  });

  const reviewSearch = document.getElementById('reviewSearch');
  if (reviewSearch) {
    reviewSearch.addEventListener('input', applyReviewFilters);
  }

  const reviewRatingFilter = document.getElementById('reviewRatingFilter');
  if (reviewRatingFilter) {
    reviewRatingFilter.addEventListener('change', applyReviewFilters);
  }

  updateReviewPendingCount();

  document.querySelectorAll('.review-filter-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      setReviewStatusFilter(this.getAttribute('data-review-filter') || 'all');
      applyReviewFilters();
    });
  });

  function renumberCompleteSetRowsFromOrder() {
    const body = document.getElementById('setsManageBody');
    if (!body) return;

    Array.from(body.querySelectorAll('.sets-manage-row')).forEach((row, index) => {
      const setId = row.getAttribute('data-set-id');
      if (!setId || setId.startsWith('new-')) return;

      row.setAttribute('data-set-sort', String(index));

      const input = row.querySelector('.set-order-input');
      if (input) input.value = index;

      const originalSort = input ? (parseInt(input.getAttribute('data-original'), 10) || 0) : 0;
      const toggle = row.querySelector('.set-active-toggle');
      const currentActive = toggle ? toggle.checked : true;
      const originalActive = toggle ? toggle.getAttribute('data-original') === 'true' : true;

      const sortChanged = index !== originalSort;
      const activeChanged = currentActive !== originalActive;

      if (sortChanged || activeChanged) {
        if (!pendingSetEdits[setId]) {
          pendingSetEdits[setId] = {
            title: row.getAttribute('data-set-title'),
            description: row.getAttribute('data-set-description'),
            product_ids: (row.getAttribute('data-set-pids') || '').split(',').filter(Boolean),
            is_custom: row.getAttribute('data-set-is-custom') === 'true'
          };
        }

        pendingSetEdits[setId].sort_order = index;
        pendingSetEdits[setId].is_active = currentActive;
      } else if (pendingSetEdits[setId] && !pendingSetEdits[setId]._modal) {
        delete pendingSetEdits[setId];
      }
    });

    checkUnsavedChanges();
  }

  function getDragAfterElement(container, y) {
    const draggableElements = [...container.querySelectorAll('.sets-manage-row:not(.is-dragging)')];

    return draggableElements.reduce((closest, child) => {
      const box = child.getBoundingClientRect();
      const offset = y - box.top - box.height / 2;

      if (offset < 0 && offset > closest.offset) {
        return { offset: offset, element: child };
      }

      return closest;
    }, { offset: Number.NEGATIVE_INFINITY, element: null }).element;
  }

  function initCompleteSetsDragSort() {
    const body = document.getElementById('setsManageBody');
    if (!body || body.getAttribute('data-drag-sort-ready') === 'true') return;

    body.setAttribute('data-drag-sort-ready', 'true');

    body.addEventListener('dragstart', function(e) {
      const row = e.target.closest('.sets-manage-row');
      if (!row) return;

      row.classList.add('is-dragging');
      if (e.dataTransfer) {
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', row.getAttribute('data-set-id') || '');
      }
    });

    body.addEventListener('dragend', function(e) {
      const row = e.target.closest('.sets-manage-row');
      if (row) row.classList.remove('is-dragging');
      body.querySelectorAll('.drag-over').forEach(el => el.classList.remove('drag-over'));
      renumberCompleteSetRowsFromOrder();
    });

    body.addEventListener('dragover', function(e) {
      e.preventDefault();

      const dragging = body.querySelector('.sets-manage-row.is-dragging');
      if (!dragging) return;

      const afterElement = getDragAfterElement(body, e.clientY);
      body.querySelectorAll('.drag-over').forEach(el => el.classList.remove('drag-over'));

      if (afterElement == null) {
        body.appendChild(dragging);
      } else {
        afterElement.classList.add('drag-over');
        body.insertBefore(dragging, afterElement);
      }
    });
  }

  initCompleteSetsDragSort();

});
